import { Component, OnInit, TemplateRef, ChangeDetectorRef, ViewChild, EventEmitter, Output, ElementRef, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FileManagerService } from '../services/fileManager.services';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MovetoFileManagerComponent } from 'src/app/middleware/common/movetoFileManager/movetoFileManager.component';
import { RenameFileManagerComponent } from 'src/app/middleware/common/renameFileManagerItem/renameFileManager.component';
import { environment } from 'src/environments/environment';
import { AssociateContactRoleFileManagerComponent } from '../associate-contact-role-filemanager/associate-contact-role-filemanager.component';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
export let browserRefresh = false;
import { Clipboard } from "@angular/cdk/clipboard"
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
const FileSaver = require('file-saver');
import { COMMA, ENTER, F } from '@angular/cdk/keycodes';
import { MatRadioChange } from '@angular/material/radio';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Add3cforPccComponent } from 'src/app/middleware/common/add3cforPcc/add3cforPcc.component';
import { PaycheckErrorComponent } from 'src/app/middleware/common/paycheckError/paycheckError.component';
import { GoogleAuthService } from '../services/google-auth.service.ts';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormsService } from '../../eSignature/services/forms.service';
import { SelectFormIconComponent } from 'src/app/middleware/common/selectFormIcon/selectFormIcon.component';
import { MatSort } from '@angular/material/sort';
import { interval, Subscription } from 'rxjs';
declare let gapi: any;
declare let google: any;

@Component({
  selector: 'app-file-dashboard',
  templateUrl: './file-dashboard.component.html',
  styleUrls: ['./file-dashboard.component.scss'],
})

export class FileDashboardComponent implements OnInit {

  shareFile: boolean = true;
  showShareFile: boolean = false;
  ShowRequestButton: boolean = false;
  showEmailFile: boolean = false;
  showShareDocumentIn3c: boolean = false;

  public browserRefresh: boolean;
  showGrid: boolean = false;
  showList: boolean = true;

  formDialog: FormGroup;
  databaseId: any;
  organizationId: string;
  currentUser: any;
  noRecordFound: boolean = false;
  foldersList: any = ([] = []);
  folderId: number = 0;
  SelectedRecordForDeleFav: boolean = false;
  selectedRecordDeleteArray: any = [];
  foldersClicked: Array<any> = [];
  rootFoldersList: Array<any> = [];
  selection = new SelectionModel<any>(true, []);
  parentId: number = 0;
  clickEventsubscription: Subscription;
  clickEventsubscriptionsharequicklink12: Subscription
  clickEventsubscription1: Subscription;
  clickEventsubscription2: Subscription;
  clickEventsubscription3: Subscription;
  clickEventsubscription4: Subscription;
  clickEventsubscription5: Subscription;
  clickEventsubscription6: Subscription;
  menuHeader: any = [];
  foldersListShow: boolean = false;
  displayedColumns: Array<any> = [];
  pageIndex: any;
  pageSize: any;
  pageSizeOptions: any[] = [0, 15, 25, 50, 100];
  paginatorTotalLength: any;
  // pageModelData = {
  //   pageIndex: 1,
  //   pageSize: 15,
  //   searchValue: '',
  // };  
  pageModelData = {
    pageIndex: 0,
    pageSize: 0,
    searchValue: '',
  };
  dataSource: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Output() documentViewer = new EventEmitter<boolean>();
  showFavDeletePanel: boolean = false;
  responseHolder: any;
  fileToUpload: File = null;
  showLocalPanel: boolean = false;
  ItemId: any;
  @ViewChild('Input') InputFile: ElementRef;
  OfficeIDList: any = [];
  myOfficeID: any;
  Module: string = "";
  isShowForm: any = true;
  isSharedWithMe: any = false;
  sendfileManagerItemID: number = 0;
  spinner: boolean = false;
  searchKey: any = "";
  azureblobPath: any;
  getAllSubfolderListResponseHolder: any = [] = [];
  fileManagerList: any = [] = [];
  documentTypeFieldsList: any = [] = [];
  FieldColumnToogle: any = [] = [];
  subFolderID: number = 0;
  startDate = new FormControl(new Date());
  endDate = new FormControl(new Date());
  aisearchkeywords: string = "";
  isFilesOnly: boolean = false;
  formIcon: any;
  receivedQuickLinkData: any;
  showGridopt() {
    this.showGrid = true;
    this.showList = false;
  }

  showListopt() {
    this.showList = true;
    this.showGrid = false;
  }

  subscription: Subscription;
  ShowCustomColumn: boolean = false;
  showCustomColumninList: any = [] = [];

  ranges = {
    Today: [moment(), moment()],
    'This Week': [moment().startOf('week'), moment().endOf('week')],
    'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };
  alwaysShowCalendars: boolean;
  showRangeLabelOnInput: boolean;
  keepCalendarOpeningWithRange: boolean;
  fileManagerFolderReportList: any = [] = [];
  // startDate:any;
  // endDate:any; 
  fileTypes: any = [] = [];
  fileType: string = "All";
  fileTypeSelected: number = 1;
  filterByDate: any = "";
  Filters: any = {};
  fileManagerItemID: number = 0;
  TypeIdDrp: number = 0;
  documentTypeList: any = [] = [];
  coreUserList: any = [] = [];
  coreFieldSaveCompare: any = [] = [];
  coreFieldList: any = [] = [];
  myFormGroup: FormGroup;
  dropdownlist: any = [] = [];
  dropdownlistType: any;
  newdropdownlist: any;
  multipleDropdownList: any;
  checkBoxList: any;
  newcheckBoxList: any;
  chkStatusArry: any;
  TypeList: any;
  tagCtrl = new FormControl();
  filteredTags: Observable<string[]>;

  newtag: string[] = [];
  tags: string[] = [];
  allTags: string[] = [];
  AllTagList: any;
  selectedtagsId: any = [];
  cityOption: string[] = [];
  filteredOptions: Observable<string[]>;
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;
  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  TypeListForDropDown: any = [] = [];
  minFromDate: Date;
  maxFromDate: Date | null;
  minToDate: Date | null;
  maxToDate: Date;
  // fromDate:string="";
  // toDate:string="";
  fromDate: any;
  toDate: any;
  DocSizeFrom: any;
  DocSizeTo: any;
  userList: any = [] = [];
  timeout = null;
  ShowPointClickCare: boolean = false;
  fileId: string = "";

  documentCategoryList = [
    {
      id: 1,
      description: "Test"
    },
    {
      id: 2,
      description: "Demo"
    },

  ];

  @ViewChild(MatSort) sort: MatSort;
  private destroy$ = new Subject<void>(); // Subject to manage subscription lifecycle

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private formService: FormsService, private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private toastr: ToastrService, private fileManagerService: FileManagerService, private router: Router, private dialog: MatDialog,
    private _dataSharingService: DataSharingService, private cdr: ChangeDetectorRef, private loaderService: LoaderService,
    private statusConstant: StatusConstant, private clipboard: Clipboard, private datePipe: DatePipe,
    private authService: GoogleAuthService, private renderer: Renderer2,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.alwaysShowCalendars = true;
    this.keepCalendarOpeningWithRange = true;
    this.showRangeLabelOnInput = true;
    this.runFileAi = false;

    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('/filemanager')) {
          browserRefresh = router.navigated;
          if (browserRefresh == true) {
            sessionStorage.setItem('FileManagerMenuActive', 'true');
            sessionStorage.setItem('FileManagerMenuSharedActive', 'false');
          }
        }
      }
    });
  }

  ngOnInit() {
    //Call API immediately and then every 5 minutes (300000 ms)
    this.subscription = interval(200000).subscribe(() => {
      if (this.runFileAi == true) {
        if (this.isSharedWithMe == false) {
          this._dataSharingService.sendRefreshListForFileManager(true);
          this._dataSharingService.sendRefreshListForFileManagerAddFolder(this.parentId);
        }
        if (this.isSharedWithMe == true) {
          if (this.parentId == 0) {
            this.getFileFolderSharedWithMeList();
          }
          if (this.parentId > 0) {
            this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, this.permissionTypeForSharedWithMe);
          }
        }
      }
    });


    this.loadPdfJs('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js');

    // send child folders from left menu
    this.clickEventsubscriptionsharequicklink12 = null;
    this.authService.initializeAuth();
    this.browserRefresh = browserRefresh;
    if (environment.production) {
      this.showLocalPanel = false;
    } else {
      this.showLocalPanel = true;
    }

    this.fileTypes = [
      { value: 1, name: 'All' },
      { value: 2, name: 'PDF' },
      { value: 3, name: 'JPG' },
      { value: 4, name: 'HEIC' },
      { value: 5, name: 'OTHER' }
    ];

    var PointClickCare = sessionStorage.getItem('PointClickCare');
    if (PointClickCare == "true") {
      this.ShowPointClickCare = true;
    }
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == 'File Manager');
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
    }

    Module = menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (Module.length > 0) {
      this.modulenameContact = Module[0].orgModuleName;
    }
    this.subFolderID = 0;
    this.documentTypeFieldsList = [];
    this.showCustomColumninList = [];
    this.FieldColumnToogle = [];
    this.menuHeader = [];
    this.parentId = 0;
    this.isAdvFilter = false;
    this.setDisplayedColumns();

    this.route.queryParams.subscribe(params => {
      if (params['data']) {
        this.receivedQuickLinkData = this.decodeData(params['data']);
        if (this.receivedQuickLinkData.isShared == true) {
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this._dataSharingService.sendFetchleftmenufielmanager(true);
          this.breadCrumbShareWithMeQuicklink(this.receivedQuickLinkData);
        } else {
          this.isShowForm = true;
          this.isSharedWithMe = false;
          this.breadCrumbQuickLink(this.receivedQuickLinkData);
        }
        this.getAllFolder();
      } else {
        this.getFileManagerFoldersList(0, this.pageModelData, "");
        this.getAllFolder();
      }
    });

    // send child folders from left menu
    this.clickEventsubscriptionsharequicklink12 = this._dataSharingService.getSelectedFolderContentFromLeftMenuFileManager().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (!this.receivedQuickLinkData || result == "sharewithmeLeftmenu" || result == "sharewithme" || (result != '' && result != null && result != undefined)) {
        if (result == "sharewithmeLeftmenu") {
          this.receivedQuickLinkData = undefined;
        }
        if (result == "sharewithme" || result == "sharewithmeLeftmenu") {
          this.isAdvFilter = false;
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.menuHeader = [];
          this.parentId = 0;
          this.subFolderID = 0;
          this.selectedRecordDeleteArray = [];
          this.documentTypeFieldsList = [];
          this.FieldColumnToogle = [];
          this.showCustomColumninList = [];
          this.showFavDeletePanel = false;
          this.selection.clear();

          this.getFileFolderSharedWithMeList();
        }
        else if (result != '' && result != undefined) {
          this.isAdvFilter = false;
          this.showCustomColumninList = [];
          this.isShowForm = true;
          this.isSharedWithMe = false;
          this.menuHeader = result.breadCrumMenu;
          this.foldersList = result.FileManagersubFolderFolderList;
          if (this.isFilesOnly == true) {
            this.foldersList = result.FileManagersubFolderFolderList.filter(x => x.isFile === true);
          } else {
            this.foldersList = result.FileManagersubFolderFolderList;
          }
          this.paginatorTotalLength = result.count;
          this.pageModelData.pageIndex = result.pageIndex;
          this.pageIndex = result.pageIndex;
          this.pageSize = result.pageSize;
          if (this.foldersList == null) {
            this.foldersList = [];
          }
          if (this.foldersList.length > 0) {
            this.foldersListShow = false;
          } else {
            this.foldersListShow = true;
          }
          //  if(result.documentTypeFields!= undefined){
          //    this.documentTypeFieldsList= result.documentTypeFields;            
          //  }else{
          //   this.documentTypeFieldsList=[];
          //  }

          //  if(result.subFolderID!= undefined){
          //    this.subFolderID = result.subFolderID;            
          //  }else{
          //    this.subFolderID=0;
          //  } 
          //  if(result.gridSetting!= undefined){
          //    this.FieldColumnToogle = result.gridSetting;            
          //  }else{
          //    this.FieldColumnToogle=[];
          //  } 

          //  if(this.FieldColumnToogle.length>0){
          //   this.showCustomColumninList=this.FieldColumnToogle.filter(x=>x.isDisplay==true);          
          //  }     

          this.parentId = result.fileManagerItemID;
          this.selectedRecordDeleteArray = [];
          this.showFavDeletePanel = false;
          this.selection.clear();
        } else {
          // Ensure the GIS library is loaded
          window.onload = () => {
            google.accounts.id.initialize({
              client_id: this.clientId,
              callback: this.handleCredentialResponse.bind(this),
            });
            google.accounts.id.renderButton(
              document.getElementById('buttonDiv'),
              { theme: 'outline', size: 'large' } // Customization options
            );
            google.accounts.id.prompt(); // Display the One Tap prompt
          };

          if (!this.receivedQuickLinkData) {
            this.isAdvFilter = false;
            this.isShowForm = true;
            this.isSharedWithMe = false;
            this.parentId = 0;
            this.subFolderID = 0;
            this.menuHeader = [];
            this.selectedRecordDeleteArray = [];
            this.documentTypeFieldsList = [];
            this.showCustomColumninList = [];
            this.FieldColumnToogle = [];
            this.showFavDeletePanel = false;
            this.selection.clear();
          }
        }
      }
      result = "";
    });

    this.clickEventsubscription1 = this._dataSharingService.getRenamedItemForFileManager().subscribe((result) => {
      if (result != '' && result != undefined) {
        if (this.menuHeader.length > 0) {
          this.menuHeader.find((item) => item.id == result.fileManagerItemID).label = result.name;
        }
      } else {

      }
    });

    this.clickEventsubscription2 = this._dataSharingService.getRefreshListForFileManagerAddFolder().subscribe((result) => {

      if (result !== '' && result !== undefined && result != null) {
        this.getFileManagerFoldersList(result, this.pageModelData, "");
        this.receivedQuickLinkData = undefined;
      } else {
        if (!this.receivedQuickLinkData)
          this.getFileManagerFoldersList(0, this.pageModelData, "");
      }
    });

    this.clickEventsubscription3 = this._dataSharingService.getCurrentFormContactFileManager().subscribe((result) => {
      if (result != '' && result != undefined) {
        this.searchName = result;
        this.showAddContact = true;
      } else {
        this.searchName = "";
        this.showAddContact = false;
      }
    });

    this.clickEventsubscription4 = this._dataSharingService.getClosePanelFaxForFileManager().subscribe((result) => {
      if (result) {
        this.selectedRecordDeleteArray = [];
        this.showFavDeletePanel = false;
        this.selection.clear();
      }
    });

    this.clickEventsubscription5 = this._dataSharingService.getRemoveFaxDocumentForFileManager().subscribe((result) => {
      if (result) {
        var check = [];
        var fileManagerItemID = Object.values(result)[1];
        check = this.foldersList.filter(el => el.fileManagerItemID === fileManagerItemID)
        if (check.length > 0) {
          let removeIndex = this.selectedRecordDeleteArray.findIndex((itm) => itm.selectedDocument.fileManagerItemID === fileManagerItemID);
          if (removeIndex !== -1) this.selectedRecordDeleteArray.splice(removeIndex, 1);
          this.foldersList.forEach((row) => this.selection.deselect(check[0]));
        }
      }
    });

    this.clickEventsubscription6 = this._dataSharingService.getSelectedDocForGoogleDrive().subscribe((result) => {
      if (result) {
        this.selectFilesFromDragZoneFromGoogleDrive(result);
      }
    });

    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('filemanagerFolderName', this.formBuilder.control(''));
    sessionStorage.setItem('HeaderModuleName', this.Module);
    this._dataSharingService.sendSelectedModuleName(this.Module);
    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();
  }


  ngOnDestroy() {
    this.runFileAi = false;
    //this.clickEventsubscription.unsubscribe();
    this.clickEventsubscription1.unsubscribe();
    this.clickEventsubscription2.unsubscribe();
    this.clickEventsubscription3.unsubscribe();
    this.clickEventsubscription4.unsubscribe();
    this.clickEventsubscription5.unsubscribe();
    this.clickEventsubscription6.unsubscribe();
    this.clickEventsubscriptionsharequicklink12.unsubscribe();
    this.subscription.unsubscribe();
    // Emit a value to trigger unsubscription for all subscriptions using takeUntil
    this.destroy$.next();
    this.destroy$.complete(); // Complete the subject to clean up
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }


  decodeData(encodedData: string): any {
    try {
      return JSON.parse(atob(encodedData)); // Decode Base64 string back to object
    } catch (error) {
      console.error('Decoding failed:', error);
      return null;
    }
  }

  selectIcon(form) {
    const dialogRef = this.dialog.open(SelectFormIconComponent, {

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.formIcon = result;
        this.addDashboardQuicklink(form, result);
        // this.iconName = result.name;  
      }
    });
  }

  addDashboardQuicklink(form, result) {
    var ReqModel = {
      id: form.fileManagerItemID == undefined ? form.id : form.fileManagerItemID,
      name: form.name,
      favoriteType: 3, //folder
      url: "",
      IsShared: form.isSharedWithMe == undefined ? false : form.isSharedWithMe,
      icon: result.icon,
      color: result.color,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show()
    this.formService.AddDashboardFavoriteItem(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.toastr.success('Dashboard Quick Link Added successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.toastr.error('Error occurred.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  handleCredentialResponse(response: any) {
    //console.log('Encoded JWT ID token: ' + response.credential);
    // Handle the token (e.g., send it to your backend)
  }

  setDisplayedColumns() {
    this.displayedColumns = ['fileManagerItemID', 'name', 'sharedBy', 'createdOn', 'updatedOn', 'action'];
  }

  /* Share Docuemnts OPEN/CLOSE */
  getShareFile(message: boolean) {
    this.showShareFile = message;
  }

  getCloseShareFile(closeShare: boolean) {
    this.showShareFile = closeShare;
  }


  /* Share Docuemnts OPEN/CLOSE */
  getShareFileFor3C(message: boolean) {
    this.showShareDocumentIn3c = message;
  }

  getCloseShareFileFor3C(closeShare: boolean) {
    this.showShareDocumentIn3c = closeShare;
  }

  showChildFolders(folder) {
    this.parentId = folder.fileManagerItemID;
    this.menuHeader.push({
      label: folder.name,
      id: folder.fileManagerItemID,
      icon: 'navigate_next',
      permissionType: folder.permissionType
    });

    this.pageModelData = {
      pageIndex: 0,
      pageSize: 0,
      searchValue: '',
    };
    this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
    this.ItemId = this.parentId;
    sessionStorage.setItem('isShared', folder.isShared);
    this.getFileManagerFoldersDetails(this.parentId);
    this._dataSharingService.sendSelectedFolderIDForAddFolder(this.parentId);

    this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

    this.foldersList = folder.children;
    this.noRecordFound = false;
    if (this.foldersList != null) {
      this.dataSource.data = this.foldersList;
      this.pageModelData = {
        pageIndex: 0,
        pageSize: 0,
        searchValue: '',
      };
      this.SelectedRecordForDeleFav = false;
      this.selection.clear();
    }
  }

  showChildFoldersSharedWithMe(folder) {
    sessionStorage.setItem('isSharedWithMeFileManager', 'true');
    if (folder.isFile == false) {
      if (folder.fileManagerItemID == undefined) {
        this.parentId = folder.id;
      }
      if (folder.fileManagerItemID != undefined) {
        this.parentId = folder.fileManagerItemID;
      }
      this.menuHeader.push({
        label: folder.name,
        id: this.parentId,
        icon: 'navigate_next',
        isFile: folder.isFile,
        permissionType: folder.permissionType
      });
      this.permissionTypeForSharedWithMe = folder.permissionType;
      this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, folder.permissionType);
    }
    if (folder.isFile == true) {
      if (folder.fileManagerItemID == undefined) {
        this.parentId = folder.id;
      }
      if (folder.fileManagerItemID != undefined) {
        this.parentId = folder.fileManagerItemID;
      }
    }

    this.pageModelData = {
      pageIndex: 1,
      pageSize: 10,
      searchValue: '',
    };

    this.ItemId = this.parentId;
    this.getFileManagerFoldersDetails(this.parentId);
    this._dataSharingService.sendSelectedFolderIDForAddFolder(this.parentId);
    this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
    this.foldersList = folder.children;
    this.noRecordFound = false;
    if (this.foldersList != null) {
      this.dataSource.data = this.foldersList;
      this.pageModelData = {
        pageIndex: 0,
        pageSize: 10,
        searchValue: '',
      };
      this.SelectedRecordForDeleFav = false;
      this.selection.clear();
    }
    if (folder.isFile == true && folder.pageIndex == 0) {
      this.parentId = 0;
    }
  }

  documentTypeID: number = 0;

  showFileDetails(folder) {
    if (folder.isFile == true) {
      this.ItemId = folder.fileManagerItemID;
      this.documentTypeID = folder.documentTypeID;
      this.getFileManagerFoldersDetails(folder.fileManagerItemID);
    }
  }

  showFileDetailsSharedWithMe(folder) {
    if (folder.fileManagerItemID == undefined) {
      sessionStorage.setItem('isSharedWithMeFileManager', 'true');
      this.ItemId = folder.id;
      this.getFileManagerFoldersDetails(folder.id); // True-Shared with me
    }

    if (folder.fileManagerItemID != undefined) {
      sessionStorage.setItem('isSharedWithMeFileManager', 'true');
      this.ItemId = folder.fileManagerItemID;
      this.getFileManagerFoldersDetails(folder.fileManagerItemID); // True-Shared with me
    }
  }

  SelectedDocumentForFileManager: any = [];

  openDocumentViewer(message: boolean, document, templateRef: TemplateRef<any>) {
    this.folderId = document.fileManagerItemID;
    this.SelectedDocumentForFileManager = [];
    var ReqModel = {
      documentID: document.fileManagerItemID,
      documentPath: document.azureblobPath,
      documentTypeID: document.documentTypeID
    }
    this.SelectedDocumentForFileManager.push(ReqModel);
    // this._dataSharingService.sendSelectedDocumentForFileManager(ReqModel);
    this.documentViewer.emit(message);
    this.dialog.open(templateRef);
  }

  openDocumentViewerSharedWithMe(message: boolean, document, templateRef: TemplateRef<any>) {
    this.SelectedDocumentForFileManager = [];
    sessionStorage.setItem('isSharedWithMeFileManager', 'true');
    if (document.fileManagerItemID == undefined) {
      this.folderId = document.id;
      var ReqModel = {
        documentID: document.id,
        documentPath: document.url,
      }
    }

    if (document.fileManagerItemID != undefined) {
      this.folderId = document.fileManagerItemID;
      var ReqModel = {
        documentID: document.fileManagerItemID,
        documentPath: document.url,
      }
    }
    this.SelectedDocumentForFileManager.push(ReqModel);
    // this._dataSharingService.sendSelectedDocumentForFileManager(ReqModel);  
    this.documentViewer.emit(message);
    this.dialog.open(templateRef);
  }

  getCloseDocumentViewer(_message: boolean) {
    this.SelectedDocumentForFileManager = [];
    this.documentViewer.emit(false);
    this.dialog.closeAll();
  }

  breadCrumbMainClick() {
    this.isAdvFilter = false;
    this.subFolderID = 0;
    this.searchKey = "";
    this.menuHeader = [];
    this.parentId = 0;
    this.foldersListShow = false;
    this.foldersList = [];
    this.selectedRecordDeleteArray = [];
    this.showFavDeletePanel = false;
    this.selection.clear();
    this.pageModelData = {
      pageIndex: 0,
      pageSize: 0,
      searchValue: '',
    };
    this.getFileManagerFoldersList(0, this.pageModelData, "");
    this._dataSharingService.sendSelectedFolderIDForAddFolder(0);
    this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
  }

  breadCrumbMainSHaredWithMeClick() {
    this.menuHeader = [];
    this.parentId = 0;
    this.selectedRecordDeleteArray = [];
    this.selection.clear();
    this.showFavDeletePanel = false;
    this.getFileFolderSharedWithMeList();
    this._dataSharingService.sendSelectedFolderIDForAddFolder(0);
    this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
  }

  breadCrumb(menu, index) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.foldersList = menu[index].items;
    }
    this.foldersListShow = false;
    var data = this.menuHeader[index];
    this.parentId = data.id;
    this.getFileManagerFoldersList(data.id, this.pageModelData, "");
    this.getFileManagerFoldersDetails(this.parentId);
    this._dataSharingService.sendSelectedFolderIDFromLeftMenuToDashBoardFileManager(menu.id);
  }

  breadCrumbQuickLink(folder) {
    let menuHeaderQuick: any = [];
    menuHeaderQuick.push({
      label: folder.name,
      id: folder.id,
      icon: 'navigate_next',
      permissionType: 1
    });
    setTimeout(() => {
      this.menuHeader = menuHeaderQuick.filter((thing, i, arr) =>
        arr.findIndex((t) => t.id === thing.id) === i
      );
      this.parentId = folder.id;
    }, 2000); // 2000ms = 2 seconds

    this.foldersListShow = false;
    this.parentId = folder.id;
    this.getFileManagerFoldersList(folder.id, this.pageModelData, "");
    this.getFileManagerFoldersDetails(this.parentId);
    this._dataSharingService.sendSelectedFolderIDFromLeftMenuToDashBoardFileManager(folder.id);
  }

  breadCrumbShareWithMeQuicklink(folder) {
    let menuHeaderQuick: any = [];
    menuHeaderQuick.push({
      label: folder.name,
      id: folder.id,
      icon: 'navigate_next',
      permissionType: 1,
      isFile: false
    });
    setTimeout(() => {
      this.menuHeader = menuHeaderQuick.filter((thing, i, arr) =>
        arr.findIndex((t) => t.id === thing.id) === i
      );
      this.parentId = folder.id;
    }, 2000); // 2000ms = 2 seconds   
    this.showChildFoldersSharedWithMe({ type: 1, id: folder.id, isFile: false, name: folder.name, permissionType: 1 });
    this.parentId = folder.id;
    this.getFileManagerFoldersDetails(this.parentId);
    this._dataSharingService.sendSelectedFolderIDFromLeftMenuToDashBoardFileManager(folder.id);
  }

  breadCrumbShareWithMe(menu, index) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.foldersList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.showChildFoldersSharedWithMe({ type: 1, id: data.id, isFile: data.isFile, name: data.label, permissionType: data.permissionType });
    this.parentId = data.id;
    this.getFileManagerFoldersDetails(this.parentId);
    this._dataSharingService.sendSelectedFolderIDFromLeftMenuToDashBoardFileManager(menu[index].id);
  }

  openCreateFolderDialogue(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
    this.formDialog.reset();
  }

  getFileManagerFoldersList(folderId, pageData: any, search: any) {
    this.selectedRecordDeleteArray = [];
    this.selection.clear();
    this.showFavDeletePanel = false;
    if (folderId == null) {
      folderId = 0;
    }
    if (folderId == 0) {
      this.menuHeader = [];
    }
    let reqModel = {
      fileManagerItemID: folderId,
      name: search,
      isFilesOnly: this.isFilesOnly,
      pageIndex: pageData.pageIndex,
      pageSize: pageData.pageSize,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.fileManagerService.FileManagerItemsWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConstant.statusSuccess) {
        this.loaderService.hide();
        this.foldersList = response.data.children;
        this.paginatorTotalLength = response.data.count;
        this.pageModelData.pageIndex = response.data.pageIndex;
        this.pageIndex = response.data.pageIndex;
        this.pageSize = pageData.pageSize;
        if (this.foldersList == null || this.foldersList.length == 0) {
          this.foldersList = [];
          this.foldersListShow = true;
        } else {
          // this.foldersList.forEach(e => {
          //   if(e.isFile==false){
          //     let string= JSON.stringify({
          //       userID: this.currentUser.UID,
          //       organizationID: Number(this.organizationId),
          //       databaseID:Number(this.databaseId),
          //       officeID:this.myOfficeID,
          //       fileManagerItemID:e.fileManagerItemID,
          //       folderName:e.name,
          //       senderName:this.currentUser.Name,
          //     });
          //     const encryptedToken=this.encryptionAlgo.set(this.reusableClass.encryptionKey, string);
          //     const encryptedTokenWithEncoding=encodeURIComponent(encryptedToken);
          //     e.token = window.location.href.split(window.location.pathname)[0]+"/request/fileManagerdocuments?token="+encryptedTokenWithEncoding;
          //    }
          // });
          this.foldersListShow = false;
          this._dataSharingService.sendSelectedFolderIDForAddFolder(folderId);
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getFileManagerFoldersListSharedWithMe(folderId, pageData: any, permissionType) {
    this.selectedRecordDeleteArray = [];
    this.selection.clear();
    this.showFavDeletePanel = false;
    if (folderId == 0) {
      this.menuHeader = [];
    }
    let reqModel = {
      fileManagerItemID: folderId,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: permissionType
    }
    this.loaderService.show();
    this.fileManagerService.GetSharedWithMeFileManagerWithHierarchy(reqModel).subscribe(response => {
      if (response.status == this.statusConstant.statusSuccess) {
        this.loaderService.hide();
        this.SharedWithMeFormFolderList = response.data;//response.data.children;   
        if (this.SharedWithMeFormFolderList != null) {
          this.SharedWithMeFormFolderList.map((res) => {
            if (res.sharedbyFirstName != null) {
              res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
            }
            if (res.sharedbyLastName != null) {
              res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
            }
            return res;
          });
        }
        // this.paginatorTotalLength =response.data.count;   
        // this.pageModelData.pageIndex = response.data.pageIndex;
        // this.pageIndex = response.data.pageIndex;
        //  this.pageSize = pageData.pageSize
        if (this.SharedWithMeFormFolderList == null || this.SharedWithMeFormFolderList.length == 0) {
          this.SharedWithMeFormFolderList = [];
        } else {
          this._dataSharingService.sendSelectedFolderIDForAddFolder(folderId);
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getFileManagerFoldersDetails(folderId) {
    let reqModel = {
      fileManagerItemID: folderId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.fileManagerService.GetFileManagerFileDetail(reqModel).subscribe(response => {
      if (response.status == this.statusConstant.statusSuccess) {
        response.data.documentTypeID = this.documentTypeID;
        this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(response.data);
      }
    });
  }


  close() {
    this.dialog.closeAll();
  }

  kypresed($event, value) {
    if ($event.keyCode == "13") {
      this.AddFolderName(value);
    }
  }

  AddFolderName(data) {
    this.formDialog.markAsPristine();
    this.spinner = true;
    let request = {
      fileManagerItemID: 0,
      name: data.filemanagerFolderName.trim(),
      parentID: this.parentId,
      isFile: false,
      organizationID: Number(this.organizationId),
      databaseID: parseInt(this.databaseId),
      UserId: this.currentUser.UID,
      officeID: this.myOfficeID
    }
    this.loaderService.show();
    this.fileManagerService.addFolderinFileManager(request).subscribe(response => {
      if (response != undefined) {
        this.dialog.closeAll();
        this.loaderService.hide();
        var responseHolder = response;
        if (responseHolder.data == true && responseHolder.status == this.statusConstant.statusSuccess) {
          this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
          this._dataSharingService.sendRefreshListForFileManager(true);
          this.formDialog.reset();
          this.spinner = false;
          this.toastr.success('Folder created successfully.', '', {
            timeOut: 3000,
          });
        }
        if (responseHolder.data == 2 && responseHolder.status == this.statusConstant.statusSuccess) {
          this.spinner = false;
          this.toastr.warning('Folder name already exist.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

  pageEventPropogate(pageData: PageEvent) {
    if (this.isAdvFilter == true) {
      this.pageModelData.pageIndex = pageData.pageIndex + 1;
      if (pageData.pageIndex == Infinity) {
        pageData.pageIndex = 0;
      }
      this.pageModelData.pageSize = pageData.pageSize;
      this.searchAdvFilter("");
      return;
    }
    if (this.subFolderID == 0) {
      this.pageModelData.pageIndex = pageData.pageIndex + 1;
      if (pageData.pageIndex == Infinity) {
        this.pageModelData.pageIndex = 0;
      }
      this.pageModelData.pageSize = pageData.pageSize;
      this.pageModelData.searchValue;
      this.getFileManagerFoldersList(this.parentId, this.pageModelData, this.searchKey);
    } else {
      this.pageModelData.pageIndex = pageData.pageIndex + 1;
      if (pageData.pageIndex == Infinity) {
        pageData.pageIndex = 0;
      }
      this.pageModelData.pageSize = pageData.pageSize;
      this.GetDocumentsbyType(null);
    }
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.foldersList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.foldersList.forEach((row) => this.selection.select(row));
    this.selectedRecordDeleteArray = [];

    if (this.selection.selected.length > 0) {
      for (let i = 0; i < this.selection.selected.length; i++) {
        var type: number = 0;
        if (this.selection.selected[i].isFile == false) {
          type = 1;
        }
        if (this.selection.selected[i].isFile == true) {
          type = 2;
        }
        let ReqModel = {
          id: this.selection.selected[i].fileManagerItemID, // FolderID  |  FormID
          itemType: type, //{ 1- Folder, 2- Form},
          selectedDocument: this.selection.selected[i],
          //isFavorite: this.selection.selected[i].isFavorite,
        };

        this.selectedRecordDeleteArray.push(ReqModel);
      }
      this.showFavDeletePanel = true;
      //Check for Request
      var checkRequest = [];
      checkRequest = this.selectedRecordDeleteArray.filter((itm) => itm.itemType == 2);
      if (checkRequest.length > 0) {
        this.ShowRequestButton = true;
      } else {
        this.ShowRequestButton = false;
      }
    } else {
      this.showFavDeletePanel = false;
      this.selectedRecordDeleteArray = [];
      this.selection.clear();
      this.ShowRequestButton = false;
    }
  }

  //fax request started
  FaxFiles(message: boolean) {
    var SharedSelectedFile = [];
    var SharedSelectedFileNew = [];

    SharedSelectedFile = this.selectedRecordDeleteArray.filter((s) => s.itemType == 2);
    for (let i = 0; i < this.selectedRecordDeleteArray.length; i++) {
      var placeholderType = this.selectedRecordDeleteArray[i].itemType;
      if (placeholderType == 2) {
        var ReqModel = {
          "transactionID": sessionStorage.getItem('transactionID'),
          "fileManagerItemID": this.selectedRecordDeleteArray[i].selectedDocument.fileManagerItemID,
          "azureblobPath": this.selectedRecordDeleteArray[i].selectedDocument.azureblobPath,
          "pages": this.selectedRecordDeleteArray[i].selectedDocument.pages,
          "fileType": this.selectedRecordDeleteArray[i].selectedDocument.fileType,
          "isActive": this.selectedRecordDeleteArray[i].selectedDocument.isActive,
          "isDeleted": this.selectedRecordDeleteArray[i].selectedDocument.isDeleted,
          "isFile": this.selectedRecordDeleteArray[i].selectedDocument.isFile,
          "isShared": this.selectedRecordDeleteArray[i].selectedDocument.isShared,
          "name": this.selectedRecordDeleteArray[i].selectedDocument.name,
          "organizationID": this.selectedRecordDeleteArray[i].selectedDocument.organizationID,
          "parentDocumentID": this.selectedRecordDeleteArray[i].selectedDocument.parentDocumentID,
          "parentID": this.selectedRecordDeleteArray[i].selectedDocument.parentID,
        }
        SharedSelectedFileNew.push(ReqModel);
      }
    }

    if (SharedSelectedFileNew.length > 0) {
      //this.showShareFile.emit(message);
      this.showShareFile = true;
      this._dataSharingService.sendSelectedFaxDocumentForFileManager(SharedSelectedFileNew);
      //this.getAllFolders();
    }

  }


  //fax request started
  SendDocumentFiles(message: boolean) {
    var SharedSelectedFile = [];
    var SharedSelectedFileNew = [];

    SharedSelectedFile = this.selectedRecordDeleteArray.filter((s) => s.itemType == 2);
    for (let i = 0; i < this.selectedRecordDeleteArray.length; i++) {
      var placeholderType = this.selectedRecordDeleteArray[i].itemType;
      if (placeholderType == 2) {
        var ReqModel = {
          "transactionID": sessionStorage.getItem('transactionID'),
          "fileManagerItemID": this.selectedRecordDeleteArray[i].selectedDocument.fileManagerItemID,
          "azureblobPath": this.selectedRecordDeleteArray[i].selectedDocument.azureblobPath,
          "pages": this.selectedRecordDeleteArray[i].selectedDocument.pages,
          "fileType": this.selectedRecordDeleteArray[i].selectedDocument.fileType,
          "isActive": this.selectedRecordDeleteArray[i].selectedDocument.isActive,
          "isDeleted": this.selectedRecordDeleteArray[i].selectedDocument.isDeleted,
          "isFile": this.selectedRecordDeleteArray[i].selectedDocument.isFile,
          "isShared": this.selectedRecordDeleteArray[i].selectedDocument.isShared,
          "name": this.selectedRecordDeleteArray[i].selectedDocument.name,
          "organizationID": this.selectedRecordDeleteArray[i].selectedDocument.organizationID,
          "parentDocumentID": this.selectedRecordDeleteArray[i].selectedDocument.parentDocumentID,
          "parentID": this.selectedRecordDeleteArray[i].selectedDocument.parentID,
        }
        SharedSelectedFileNew.push(ReqModel);
      }
    }

    if (SharedSelectedFileNew.length > 0) {
      //this.showShareFile.emit(message);
      this.showShareDocumentIn3c = true;
      this._dataSharingService.sendSelectedFaxDocumentForFileManager(SharedSelectedFileNew);
      //this.getAllFolders();
    }

  }

  isAllSelectedRow(event, form) {
    var type: number = 0;
    if (form.isFile == false) {
      type = 1;
    }
    if (form.isFile == true) {
      type = 2;
    }
    let ReqModel = {
      id: form.fileManagerItemID, // FolderID  |  FormID
      itemType: type, //{ 1- Folder, 2- Form}
      selectedDocument: form,
      // isFavorite: form.isFavorite,
    };
    if (event.checked) {
      this.selectedRecordDeleteArray.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordDeleteArray.findIndex((itm) => itm.id === form.fileManagerItemID);
      if (removeIndex !== -1)
        this.selectedRecordDeleteArray.splice(removeIndex, 1);
    }
    if (this.selectedRecordDeleteArray.length > 0) {
      this.showFavDeletePanel = true;
      //Check for Request
      var checkRequest = [];
      checkRequest = this.selectedRecordDeleteArray.filter((itm) => itm.itemType == 2);
      if (checkRequest.length > 0) {
        this.ShowRequestButton = true;
      } else {
        this.ShowRequestButton = false;
      }
    } else {
      this.showFavDeletePanel = false;
      this.selectedRecordDeleteArray = [];
      this.selection.clear();
      this.ShowRequestButton = false;
    }
  }

  UploadedFilesDragZone: any = [] = [];
  formData: FormData;

  selectFilesFromDragZone1(event) {
    this.dialog.closeAll();
    this.loaderService.show();
    this.formData = new FormData();
    this.UploadedFilesDragZone = [];
    this.UploadedFilesDragZone = event.target.files;

    // var check=[];

    // for (let i1 = 0; i1 < this.UploadedFilesDragZone.length; i1++){
    //  var obj={
    //   lastModified:this.UploadedFilesDragZone[i1].File.lastModified,
    //   lastModifiedDate:this.UploadedFilesDragZone[i1].File.lastModifiedDate,
    //   name:this.UploadedFilesDragZone[i1].File.lastModifiedDate,
    //  }
    // }
    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        this.InputFile.nativeElement.value = "";
        return;
      }
      var documenttype = "";
      var documentName = "";
      var FullPath = this.UploadedFilesDragZone[i].name;

      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');

      var documentNameSplit = newfilename.split('.');
      //var documentNameSplit = FullPath.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];

      // if(documentNameSplit.length>2){
      //   this.toastr.warning('Please upload valid file name, or remove special character.', '', {
      //     timeOut: 3000,
      //   });
      //   this.InputFile.nativeElement.value = "";
      //   this.loaderService.hide(); 
      //   return;
      // }
      //documentName = documentName.substring(0, 30);//get first 30 chars

      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('FileDetailList', documentName + '|' + documenttype);
    }
    this.formData.append("ParentID", this.parentId.toString());
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    //this.formData.append('OfficeIDList', this.OfficeIDList);
    this.formData.append('DatabaseID', this.databaseId);
    this.fileManagerService.addFilemanagerFile(this.formData).subscribe(response => {
      if (response != undefined) {
        var responseHolder = response;
        this.loaderService.hide();
        if (responseHolder.data == true && responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this._dataSharingService.sendRefreshListForFileManager(true);
          this._dataSharingService.sendRefreshListForFileManagerAddFolder(this.parentId);
          this.formDialog.reset();
          this.toastr.success('File upload successfully.', '', {
            timeOut: 3000,
          });
        }
        if (responseHolder.data == 2 && responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.toastr.warning('File already exist.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
      }
    });

  }
  engagingMessages = [
    "Hang tight, we're uploading your file!",
    "Almost there! Your data is on its way.",
    "We’re making progress. Just a bit more patience!",
    "Your file is getting uploaded smoothly.",
    "Crunching data… great things take time!",
    "Uploading… this won’t take long!",
  ];

  showEngagingToaster = (fileName: string) => {
    let messageIndex = 0;
    const toastId = `upload-progress-${fileName}`;

    // Update the engaging message periodically
    const intervalId = setInterval(() => {
      if (messageIndex < this.engagingMessages.length) {
        this.toastr.clear();
        this.toastr.info(this.engagingMessages[messageIndex], '', {
          disableTimeOut: true,
          closeButton: true,
        });
        messageIndex++;
      } else {
        // Loop the messages once all are shown
        messageIndex = 0;
      }
    }, 5000); // Change message every 2 seconds

    return intervalId;
  };

  clearEngagingToaster = (intervalId: any, finalMessage: string) => {
    clearInterval(intervalId); // Stop the interval updates
    this.toastr.clear(); // Clear the previous toast
    this.toastr.success(finalMessage, '', { timeOut: 3000 }); // Show the success message
  };

  selectFilesFromDragZone(event: Event, fileInput: HTMLInputElement) {
    this.dialog.closeAll();
    this.loaderService.show();

    const input = event.target as HTMLInputElement;
    if (!input.files) {
      this.toastr.error('No files selected.', '', { timeOut: 3000 });
      this.loaderService.hide();
      return;
    }

    const chunkSize = 10 * 1024 * 1024; // 5 MB per chunk
    const UploadedFilesDragZone = Array.from(input.files); // Convert FileList to Array

    const processFile = async (file: File) => {
      // Remove brackets, hash, comma, and special characters except underscore and dot (for file extension)
      const fileName = file.name.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

      // Validate file name length
      if (fileName.split('.')[0].length > 120) {
        this.toastr.warning(
          'File name up to 120 characters only supported, please rename the file.',
          '',
          { timeOut: 3000 }
        );
        fileInput.value = '';
        this.InputFile.nativeElement.value = '';
        this.loaderService.hide();
        return;
      }
     
      var newfilename = fileName.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      // Validate file name for special characters
      // const documentNameSplit = fileName.split('.');
      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning(
      //     'Please upload a valid file name or remove special characters.',
      //     '',
      //     { timeOut: 3000 }
      //   );
      //   fileInput.value = '';
      //   this.InputFile.nativeElement.value = '';
      //   this.loaderService.hide();
      //   return;
      // }

      var documentNameSplit = newfilename.split('.');
      //var documentNameSplit = FullPath.split('.');      

      const documentName = documentNameSplit[0];
      const documentType = documentNameSplit[1];

      const totalChunks = Math.ceil(file.size / chunkSize);

      let intervalId: any;
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append('fileChunk', chunk);
        formData.append('chunkIndex', i.toString());
        formData.append('totalChunks', totalChunks.toString());
        formData.append('fileName', fileName);
        formData.append('FileDetailList', `${documentName}|${documentType}`);
        formData.append('ParentID', this.parentId.toString());
        formData.append('UserID', this.currentUser.UID);
        formData.append('OrganizationID', this.organizationId);
        formData.append('OfficeID', this.myOfficeID);
        formData.append('DatabaseID', this.databaseId);

        try {
          if (i + 1 == totalChunks) {
            intervalId = this.showEngagingToaster(fileName);
          }
          await this.fileManagerService.uploadChunk(formData).toPromise();
          this.toastr.clear();
          this.toastr.info(`Chunk ${i + 1}/${totalChunks} uploaded for ${fileName}`, '', {
            timeOut: 1000,
          });

        } catch (error) {
          this.loaderService.hide();
          this.toastr.error(`An error occurred during chunk upload for ${fileName}.`, '', {
            timeOut: 3000,
          });
          return;
        }
      }
      if (intervalId)
        this.clearEngagingToaster(intervalId, `File ${fileName} uploaded successfully!`);

      //this.toastr.success(`File ${fileName} uploaded successfully.`, '', { timeOut: 3000 });
    };

    const uploadFiles = async () => {
      for (const file of UploadedFilesDragZone) {
        await processFile(file);
      }
      fileInput.value = '';
      this.loaderService.hide();
      this.runFileAi=true;
      if (this.isSharedWithMe == false) {
        this._dataSharingService.sendRefreshListForFileManager(true);
        this._dataSharingService.sendRefreshListForFileManagerAddFolder(this.parentId);
      }
      if (this.isSharedWithMe == true) {
        if (this.parentId == 0) {
          this.getFileFolderSharedWithMeList();
        }
        if (this.parentId > 0) {
          this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, this.permissionTypeForSharedWithMe);
        }
      }
      this.formDialog.reset();
    };

    uploadFiles();
  }




  DeleteFolders(form) {
    var message = `Are you sure you want to delete folder?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.fileManagerItemID, // FolderID  |  FormID
          itemType: 1, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.loaderService.show();
        this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Folder deleted successfully.', '', {
                timeOut: 3000,
              });
              // let ReqModel = {
              //   id: this.parentId,
              // };
              this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
              this._dataSharingService.sendRefreshListForFileManager(null);
              this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager("");
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
              this.showFavDeletePanel = false;
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }


  DeleteFoldersSharedWithMe(form) {
    var message = `Are you sure you want to delete folder?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.id, // FolderID  |  FormID
          itemType: 1, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.loaderService.show();
        this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Folder deleted successfully.', '', {
                timeOut: 3000,
              });
              if (this.parentId == 0) {
                this.menuHeader = [];
                this.parentId = 0;
                this.selectedRecordDeleteArray = [];
                this.selection.clear();
                this.showFavDeletePanel = false;
                this.getFileFolderSharedWithMeList();
                this._dataSharingService.sendSelectedFolderIDForAddFolder(0);
                this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
              } else {
                this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, form.permissionType);
              }
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }

  DeleteFile(form) {
    var message = `Are you sure you want to delete file?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.fileManagerItemID, // FolderID  |  FormID
          itemType: 2, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.loaderService.show();
        this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('File deleted successfully.', '', {
                timeOut: 3000,
              });
              // let ReqModel = {
              //   id: this.parentId,
              // };
              this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
              this._dataSharingService.sendRefreshListForFileManager(true);
              this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager("");
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
              this.showFavDeletePanel = false;
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }


  DeleteFileSharedWithMe(form) {
    var message = `Are you sure you want to delete file?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        let request = {
          id: form.id, // FolderID  |  FormID
          itemType: 2, //{ 1- Folder, 2- Form}
        };

        this.selectedRecordDeleteArray.push(request);

        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.loaderService.show();
        this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('File deleted successfully.', '', {
                timeOut: 3000,
              });
              if (this.parentId == 0) {
                this.menuHeader = [];
                this.parentId = 0;
                this.selectedRecordDeleteArray = [];
                this.selection.clear();
                this.showFavDeletePanel = false;
                this.getFileFolderSharedWithMeList();
                this._dataSharingService.sendSelectedFolderIDForAddFolder(0);
                this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
              } else {
                this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, form.permissionType);
              }
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }

  DeleteSelecteOrAllFolders() {
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.loaderService.show();
        this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 3000,
              });
              // let ReqModel = {
              //   id: this.parentId,
              // };            
              this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
              //  this._dataSharingService.sendRefreshListForFileManager(true);
              this.showFavDeletePanel = false;
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }


  DeleteSelecteOrAllFoldersForFileManager() {
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var ReqModel = {
          items: this.selectedRecordDeleteArray,
          actionType: -1, //(-1 For Remove),(1 For Favorite)
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),
        };
        this.loaderService.show();
        this.fileManagerService.DeleteFileManagerItems(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Record Deleted successfully.', '', {
                timeOut: 3000,
              });
              this.showFavDeletePanel = false;
              this.selectedRecordDeleteArray = [];
              this.selection.clear();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }

  MoveTo(folder) {
    var parentId = 0;
    if (folder.isFile == false) {
      parentId = folder.fileManagerItemID;
    } else {
      parentId = folder.parentID;
    }
    const dialogRef = this.dialog.open(MovetoFileManagerComponent, {
      data: {
        fileManagerItemID: folder.fileManagerItemID,
        parentId: parentId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this._dataSharingService.getSelectedParentFolderIDForMoveFileManagerItem().subscribe(response => {
        if (result != undefined) {
          if ((response?.fileManagerItemID == 0) || (response?.fileManagerItemID == undefined)) {
            this.breadCrumbMainClick();
          } else {
            this.showChildFolders(response);
            this.menuHeader = result;
          }
          this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
          this._dataSharingService.sendRefreshListForFileManager(true);
          this.showFavDeletePanel = false;
          this.selectedRecordDeleteArray = [];
          this.selection.clear();
        }
      });
    });
  }

  renameFileManagerItem(fileManagerItemDetails) {
    const dialogRef = this.dialog.open(RenameFileManagerComponent, {
      data: {
        fileManagerItemID: fileManagerItemDetails,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
        this._dataSharingService.sendRefreshListForFileManager(true);
        this.showFavDeletePanel = false;
        this.selectedRecordDeleteArray = [];
        this.selection.clear();
      }
    });
  }

  renameFileManagerItemSharedWithMe(fileManagerItemDetails) {
    fileManagerItemDetails.fileManagerItemID = fileManagerItemDetails.id;
    const dialogRef = this.dialog.open(RenameFileManagerComponent, {
      data: {
        fileManagerItemID: fileManagerItemDetails,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

        if (this.parentId == 0) {
          this.menuHeader = [];
          this.parentId = 0;
          this.selectedRecordDeleteArray = [];
          this.selection.clear();
          this.showFavDeletePanel = false;
          this.getFileFolderSharedWithMeList();
          this._dataSharingService.sendSelectedFolderIDForAddFolder(0);
          this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
        } else {
          this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, fileManagerItemDetails.permissionType);
          // this.parentId =fileManagerItemDetails.id;
          // this.getFileManagerFoldersList(fileManagerItemDetails.id,this.pageModelData,"");
          // this.getFileManagerFoldersDetails(this.parentId);   
          // this._dataSharingService.sendSelectedFolderIDFromLeftMenuToDashBoardFileManager(fileManagerItemDetails.id); 
        }
      }
    });
  }

  // Shared File Folder //
  SharedWithMeFormFolderList: any = [] = [];
  mainModuleNameFileManager: string = "File Manager";

  addContactOrRole(form) {
    this.sendfileManagerItemID = form.fileManagerItemID;
    if (form.isFile == false) {
      var FolderID = form.fileManagerItemID;
    }
    if (form.isFile == true) {
      var FileID = form.fileManagerItemID;
    }
    const dialogRef = this.dialog.open(AssociateContactRoleFileManagerComponent, {
      id: 'addContactOrRoleDialog',
      panelClass: 'custom-modalbox',
      data: {
        moduleName: 'FileManager',
        FileFolderID: FolderID,
        FileID: FileID,
        isFile: form.isFile,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result != undefined) {
        this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
        this._dataSharingService.sendRefreshListForFileManager(true);
      }
    });
  }


  getFileFolderSharedWithMeList() {
    var ReqModel = {
      fileManagerItemID: 0,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.loaderService.show();
    this.fileManagerService.GetSharedWithMeFileManager(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.responseHolder = response;
        this.SharedWithMeFormFolderList = [];
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeFormFolderList = this.responseHolder.data;
          if (this.SharedWithMeFormFolderList != null) {
            this.SharedWithMeFormFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
        }
        else {
          this.loaderService.hide();
          this.SharedWithMeFormFolderList = [];
        }
      }
      else {
        this.loaderService.hide();
        this.SharedWithMeFormFolderList = [];
      }
    });

  }

  searchName: string = "";
  typeId: number = 0;
  showAddContact: boolean = false;
  formFolderIDSendToAPI: number = 0;
  formIDSendToAPI: number = 0;
  mainModuleName: string = "";
  modulenameContact: string = "";

  getCloseAddNew(_message) {
    this.searchName = "";
    this.showAddContact = false;
    this.dialog.closeAll();
  }

  uuid() {
    var uuidValue = "", k, randomValue;
    for (k = 0; k < 32; k++) {
      randomValue = Math.random() * 16 | 0;
      if (k == 8 || k == 12 || k == 16 || k == 20) {
        uuidValue += "-"
      }
      uuidValue += (k == 12 ? 4 : (k == 16 ? (randomValue & 3 | 8) : randomValue)).toString(16);
    }
    return uuidValue;
  }


  linkCopy(folder: any) {
    if (folder.isFile == false) {
      //  let GUid = this.uuid(); 

      //  var date = new Date(); // Now
      //  date.setDate(date.getDate() + 30);

      // let string= JSON.stringify({
      //   userID: this.currentUser.UID,
      //   organizationID: Number(this.organizationId),
      //   databaseID:Number(this.databaseId),
      //   officeID:this.myOfficeID,
      //   fileManagerItemID:folder.fileManagerItemID,
      //   folderName:folder.name,
      //   senderName:this.currentUser.Name,
      // });
      // const encryptedToken=this.encryptionAlgo.set(this.reusableClass.encryptionKey, string);
      // const encryptedTokenWithEncoding=encodeURIComponent(encryptedToken);
      let URL = window.location.href.split(window.location.pathname)[0] + "/request/fileManagerdocuments?token=" + folder.token;
      this.clipboard.copy(URL);
      this.toastr.success("Link Copied.", '', {
        timeOut: 3000,
      });
    }
  }

  linkCopyFiles(folder: any) {
    if (folder.isFile == true) {
      let URL = window.location.href.split(window.location.pathname)[0] + "/request/fileManagerviewer?token=" + folder.token;
      this.clipboard.copy(URL);
      this.toastr.success("Link Copied.", '', {
        timeOut: 3000,
      });
    }
  }


  //download Single File
  DownloadSigleFile(document) {
    const selectedFileName = document.azureblobPath.split('/').pop();
    this.loaderService.show();
    this.fileManagerService.getAttachment(selectedFileName, document.azureblobPath).subscribe((response) => {
      if (response !== undefined) {
        this.loaderService.hide();
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, selectedFileName);
      } else {
        this.loaderService.hide();
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }


  //download Single File Shared With Me
  DownloadSigleFileSharedWithMe(document) {
    const selectedFileName = document.url.split('/').pop();
    this.loaderService.show();
    this.fileManagerService.getAttachment(selectedFileName, document.url).subscribe((response) => {
      if (response !== undefined) {
        this.loaderService.hide();
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, selectedFileName);
      } else {
        this.loaderService.hide();
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }

  openAIDetail: any;
  openbindFieldsDetail: boolean = false;
  openAIToolDetail: boolean = false;
  folderID: number = 0;
  transactionIDForTask: number = 0;
  typeIdForTask = 1;
  NameForTask = "";
  EmailForTask = "";
  ImageForTask = "";
  statusType = "";
  @Output() openBindFieldDetail = new EventEmitter<boolean>();

  openAIBinding(document: any) {
    document.transactionID = 0;
    document.folderID = 0;
    document.modulename = this.Module;
    document.mainModulename = this.mainModuleNameFileManager;
    document.typeId = 1;
    //document.name="";
    document.email = "";
    document.imageUrl = "";
    document.status = "";
    this._dataSharingService.sendSelectedDocForBindAI(document);
    this.openbindFieldsDetail = true;
    this.openBindFieldDetail.emit(true);
    //this._dataSharingService.openAIBindingFileDashboard(true);
  }

  openAIBindingSharedWithMe(document: any) {
    document.transactionID = 0;
    document.folderID = 0;
    document.modulename = this.Module;
    document.mainModulename = this.mainModuleNameFileManager;
    document.typeId = 1;
    //document.name="";
    document.email = "";
    document.imageUrl = "";
    document.status = "";
    document.azureblobPath = document.url;
    document.fileManagerItemID = document.id;
    this._dataSharingService.sendSelectedDocForBindAI(document);
    this.openbindFieldsDetail = true;
    this.openBindFieldDetail.emit(true);
    //this._dataSharingService.openAIBindingFileDashboard(true);
  }

  FileManagerId: number = 0;
  documentNames: string = "";
  docFrom: number = 4;
  openAITools(document: any) {
    this.openAIToolDetail = true;
    this.azureblobPath = document.azureblobPath;
    this.FileManagerId = document.fileManagerItemID;
    this.documentNames = document.name;
    this.parentIDForAddFiles = document.parentID;
  }

  permissionTypeForSharedWithMe: any;

  openAIToolsSharedWithMe(document: any) {
    this.openAIToolDetail = true;
    this.permissionTypeForSharedWithMe = document.permissionType;
    this.azureblobPath = document.url;
    this.FileManagerId = document.id;
    this.documentNames = document.name;
  }

  Search(filterKey): void {
    if (filterKey !== "*") {
      this.searchKey = filterKey;
    }

    if (filterKey != "") {
      if (filterKey == "*") {
        filterKey = "";
      }
      this.pageModelData.pageIndex = 1;
      this.pageModelData.pageSize = 10;
      this.getFileManagerFoldersList(0, this.pageModelData, this.searchKey);
    } else {
      this.pageModelData.pageIndex = 1;
      this.pageModelData.pageSize = 10;
      this.getFileManagerFoldersList(0, this.pageModelData, "");
    }
  }

  SearchFilter() {
    if (this.searchKey != "") {
      this.pageModelData.pageIndex = 1;
      this.pageModelData.pageSize = 10;
      this.getFileManagerFoldersList(0, this.pageModelData, this.searchKey);
    } else {
      this.pageModelData.pageIndex = 1;
      this.pageModelData.pageSize = 10;
      this.getFileManagerFoldersList(0, this.pageModelData, "");
    }
  }

  /* AI DETAL OPEN/CLOSE */
  getAIDetail(message: boolean) {
    this.openAIDetail = message;
  }

  getAIClose(closeDetail: boolean) {
    this.openAIDetail = closeDetail;
  }

  getBindFieldDetail(message: boolean) {
    this.openbindFieldsDetail = message;
  }


  getCloseBindFieldDetail() {
    this.openbindFieldsDetail = false;
  }

  getAIToolDetail(message: boolean) {
    this.openAIDetail = message;
  }

  getCloseAIToolDetail() {
    if (this.isSharedWithMe == false) {
      this.openAIToolDetail = false;
      //this.getFileManagerFoldersList(0,this.pageModelData,"");
      this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
      this.searchName = "";
      this.showAddContact = false;
    } else {
      this.openAIToolDetail = false;
      this.searchName = "";
      this.showAddContact = false;
      this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, this.permissionTypeForSharedWithMe);
    }

  }


  //email request started
  EmailFiles(message: boolean) {
    var SharedSelectedFile = [];
    var SharedSelectedFileNew = [];

    SharedSelectedFile = this.selectedRecordDeleteArray.filter((s) => s.itemType == 2);
    for (let i = 0; i < this.selectedRecordDeleteArray.length; i++) {
      var placeholderType = this.selectedRecordDeleteArray[i].itemType;
      if (placeholderType == 2) {
        var ReqModel = {
          "transactionID": sessionStorage.getItem('transactionID'),
          "fileManagerItemID": this.selectedRecordDeleteArray[i].selectedDocument.fileManagerItemID,
          "azureblobPath": this.selectedRecordDeleteArray[i].selectedDocument.azureblobPath,
          "pages": this.selectedRecordDeleteArray[i].selectedDocument.pages,
          "fileType": this.selectedRecordDeleteArray[i].selectedDocument.fileType,
          "isActive": this.selectedRecordDeleteArray[i].selectedDocument.isActive,
          "isDeleted": this.selectedRecordDeleteArray[i].selectedDocument.isDeleted,
          "isFile": this.selectedRecordDeleteArray[i].selectedDocument.isFile,
          "isShared": this.selectedRecordDeleteArray[i].selectedDocument.isShared,
          "name": this.selectedRecordDeleteArray[i].selectedDocument.name,
          "organizationID": this.selectedRecordDeleteArray[i].selectedDocument.organizationID,
          "parentDocumentID": this.selectedRecordDeleteArray[i].selectedDocument.parentDocumentID,
          "parentID": this.selectedRecordDeleteArray[i].selectedDocument.parentID,
        }
        SharedSelectedFileNew.push(ReqModel);
      }
    }

    if (SharedSelectedFileNew.length > 0) {
      this.showEmailFile = true;
      this._dataSharingService.sendSelectedFaxDocumentForFileManager(SharedSelectedFileNew);
    }

  }

  getCloseEmailFile(closeShare: boolean) {
    this.showEmailFile = closeShare;
  }

  AllTypeList: any = [] = [];
  ToogleColumnFields: any = [] = [];
  SubmitColumnsButton: boolean = false;
  FileManagerFolderId: number = 0;

  getFieldColumnValues(FieldColumn, item) {
    if (item.fields != null) {

      var data = [];
      data = item?.fields.filter(x => x.fieldID == FieldColumn.fieldID);
      if (data != undefined) {
        if (data.length > 0) {
          if (data[0].fieldName == "Type" && data[0].fieldTypeName == "Dropdown") {
            var checkdrp = []
            checkdrp = this.AllTypeList.filter(x => x.subFolderID == Number(data[0].value))
            if (checkdrp.length > 0) {
              return checkdrp[0].folderName;
            } else {
              return '--';
            }
          }
          if (data[0].fieldTypeName == "Date") {
            if (data[0].value != "") {
              return this.datePipe.transform(data[0].value, 'MM-dd-yyyy');;
            } else {
              return '--';
            }
          }
          if (data[0].value != "") {
            return data[0].value;
          } else {
            return '--';
          }
        } else {
          return '--';
        }
      }

    }
  }

  customizeColumn(templateRef: TemplateRef<any>) {
    this.SubmitColumnsButton = false;
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  isAdvFilter = false;

  applyAdvFilter(templateRef: TemplateRef<any>) {
    this.isAISearch = false;
    this.fromDate = "";
    this.toDate = "";
    this.authorBy = "";
    this.authorByValue = "";
    this.Tagkeywords = "";
    this.aisearchkeywords = "";
    this.coreUserList = [];
    this.userList = [];
    this.fileTypes = [];
    this.getFileAuthorsList();
    this.getfileTypesList();
    this.isExactDocumentName = false;
    this.isExactKeywords = false;
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    let group = {};
    this.myFormGroup = new FormGroup(group);
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  changedToggle(items, event) {
    this.SubmitColumnsButton = true;
    if (this.FieldColumnToogle.length > 0) {
      this.FieldColumnToogle.find((item) => item.fieldID == items.fieldID).isDisplay = event.checked;
    }
    //  this.FieldColumnToogle.forEach((s) => {
    //   if (s.fieldID === item.fieldID) {
    //    // s.fieldID = item.fieldID;
    //     //s.folderID = this.FileManagerFolderId;//17;
    //    // s.subFolderID = this.subFolderID,
    //     s.isDisplay = event.checked;
    //     //s.viewOrder = item.viewOrder;
    //   }
    // });     
  }

  onSubmitColumns() {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == 'File Manager');
    if (Module.length > 0) {
      this.FileManagerFolderId = Module[0].folderID;
    }

    var customizationGridUserSettings = [];
    if (this.FieldColumnToogle.length > 0) {
      this.FieldColumnToogle.forEach((ele) => {
        var Fields = {
          fieldID: ele.fieldID,
          folderID: this.FileManagerFolderId,
          subFolderID: this.subFolderID,
          isDisplay: ele.isDisplay,
          viewOrder: ele.viewOrder,
        };
        customizationGridUserSettings.push(Fields);
      });
    }
    var obj = {
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList,
      customizationGridUserSetting: customizationGridUserSettings,
    }
    this.loaderService.show();
    this.fileManagerService.updateCoreFieldColumnList(obj).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.close();
          this.toastr.success('Customize column update successfullt.', '', {
            timeOut: 1000,
          });
          this.GetDocumentsbyType(null);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  GetDocumentsbyType(item) {
    if (item == null) {
      this.subFolderID = this.subFolderID;
    } else {
      this.subFolderID = item.subFolderID;
    }
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == 'File Manager');
    if (Module.length > 0) {
      this.FileManagerFolderId = Module[0].folderID;
    }
    this.showCustomColumninList = [];
    var ReqModel = {
      fileManagerItemID: 0,
      documentTypeID: this.subFolderID,
      name: "",
      pageSize: 10,
      pageIndex: 0,
      searchKey: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList,
      moduleFolderID: this.FileManagerFolderId
    }
    this.fileManagerService.getDocumentsbyType(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.foldersList = this.responseHolder.data.fileManagerItems;
          this.documentTypeFieldsList = this.responseHolder.data.documentTypeFields;
          this.FieldColumnToogle = this.responseHolder.data.gridSetting;
          if (this.foldersList.length > 0) {
            this.foldersListShow = false;
          } else {
            this.foldersListShow = true;
          }
          if (this.FieldColumnToogle != null) {
            this.showCustomColumninList = this.FieldColumnToogle.filter(x => x.isDisplay == true);
          } else {
            this.showCustomColumninList = [];
          }
          this.paginatorTotalLength = this.responseHolder.data.count;
          this.pageModelData.pageIndex = this.responseHolder.data.pageIndex;
          this.pageIndex = this.responseHolder.data.pageIndex;
          this.pageSize = this.responseHolder.data.pageSize;
        }
      }
    });
  }


  getAllFolder() {
    var obj = {
      userID: this.currentUser.UID,
      databaseID: parseInt(sessionStorage.getItem('databaseId')),
      folderID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList,
      organizationID: Number(sessionStorage.getItem('organizationID'))
    }
    this.fileManagerService.getAllFolderlist(obj).subscribe((response) => {
      if (response != undefined) {
        this.getAllSubfolderListResponseHolder = response;
        if (this.getAllSubfolderListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.getAllSubfolderListResponseHolder.data.forEach((element) => {
            if (element.folderName == 'File Manager') {
              this.fileManagerFolderReportList = element.subFolders;
              if (this.fileManagerFolderReportList.length > 0) {
                this.fileManagerFolderReportList.forEach(e => {
                  e.name = e.folderName
                });
              }
              if (this.fileManagerFolderReportList != null) {
                this.fileManagerFolderReportList = this.fileManagerFolderReportList;
              } else {
                this.fileManagerFolderReportList = [];
              }
            }
          });
        } else {
        }
      }
    });
  }

  // rangeClicked(range) {
  //   if (!(range.startDate == null && range.endDate == null)) {
  //     this.startDate=moment(range.startDate).format("MM/DD/YYYY");
  //     this.endDate=moment(range.endDate).format("MM/DD/YYYY");
  //   }
  // }

  // datesUpdated(range) {
  //   if (!(range.startDate == null && range.endDate == null)) {
  //     this.startDate=moment(range.startDate).format("MM/DD/YYYY");
  //     this.endDate=moment(range.endDate).format("MM/DD/YYYY");
  //   }
  // } 

  onDocumentTypeChange(event: any) {
    this.TypeIdDrp = Number(event.value);
    this.GetFileFields();
  }


  GetFileFields() {
    var reqModel = {
      //fileID: this.fileManagerItemID,
      documentTypeID: this.TypeIdDrp,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    }
    this.loaderService.show();
    this.fileManagerService.getFileFields(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {

          this.documentTypeList = response.data.docTypes;
          this.coreUserList = response.data.docTypeFields;
          this.coreFieldSaveCompare = response.data.docTypeFields;
          this.coreFieldList = response.data.docTypeFields;

          if (this.coreUserList.length > 0) {
            this.coreUserList.forEach(e => {
              e.fieldValue = e.value
            });
          }
          //this.TypeListForDropDown =response.data.docTypes;
          //this.TypeListForDropDown.splice(0,0,{folderName: "Select",isChecked: false,subFolderID: 0});

          // var TypeData =  this.coreUserList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type'); 

          // if(TypeData!=undefined && TypeData!='' && TypeData!=null && isFromDDlType==false)
          // {
          //   this.TypeIdDrp=Number(TypeData[0].fieldValue);
          // }
          // var taglist;
          // taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          // if (taglist.length > 0 && taglist !=undefined) {
          //   this.tags = [];
          //   if(taglist[0].fieldValue != ""){
          //     var str = taglist[0].fieldValue;
          //     var selectedValues = str.replace(/^,|,$/g, '');
          //     this.tags = selectedValues.split(',');             
          //   }
          //   else {
          //     this.tags=[];
          //   }           
          // }
          // else {
          //   this.tags=[];
          // }   

          // var NewList;
          // NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          // var type;
          // type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          // NewList.splice(1, 0, type[0]);
          // this.coreUserList = NewList;

          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          // let multiNameArray = [];
          // let ArrayWithGroupedElement = [];
          // this.coreUserList = this.coreUserList.filter((s) => s.availableOn != 2); 
          // this.coreUserList = this.coreUserList.filter((s) => s.rolePermission != 2);

          // this.coreUserList.forEach((formControl) => {
          //   let count = multiNameArray.filter((x) => x.fieldID == formControl.fieldID).length;
          //   if (count == 0) {
          //       multiNameArray.push(formControl);
          //        //  Save control name and ID
          //       this.arryaControlNameIdpare.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subFolderID:formControl.subFolderID
          //       });
          //       this.arrayControlNameSubfolderID.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subfolderID:formControl.subFolderID
          //       });

          //       if(formControl.fieldName.includes('Address'))
          //       {
          //        formControl.address.forEach((ac,i) =>  {
          //         if(i>0)
          //          this.arryaControlNameIdpare.push({
          //            name:this.getAddressTypeFieldName(ac.childFieldType),
          //            id:ac.id,
          //            subFolderID:ac.subFolderID
          //          });
          //          this.arrayControlNameSubfolderID.push({
          //           name:this.getAddressTypeFieldName(ac.childFieldType),
          //           id:ac.id,
          //           subfolderID:formControl.subFolderID
          //         });
          //        });
          //       }        
          //   }
          //  else if (count > 0) {
          //     multiNameArray.push(formControl);
          //     formControl.fieldName = formControl.fieldName + count;
          //        //  Save control name and ID
          //       this.arryaControlNameIdpare.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subFolderID:formControl.subFolderID
          //       });
          //       this.arrayControlNameSubfolderID.push({
          //         name:formControl.fieldName,
          //         id:formControl.id,
          //         subfolderID:formControl.subFolderID
          //       });
          //       if(formControl.fieldName.includes('Address')){
          //        formControl.address.forEach((ac,i) => {
          //          if(i>0)
          //          this.arryaControlNameIdpare.push({
          //            name:this.getAddressTypeFieldName(ac.childFieldType)+count,
          //            id:ac.id,
          //            subFolderID:ac.subFolderID
          //          });
          //          this.arrayControlNameSubfolderID.push({
          //           name:this.getAddressTypeFieldName(ac.childFieldType),
          //           id:ac.id,
          //           subfolderID:formControl.subFolderID
          //         });
          //        });
          //       }           
          //   }
          // });


          // this.coreUserList.forEach((formControl) => {
          //   let count = ArrayWithGroupedElement.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldName.length > 0).length;
          //   let elements = this.coreUserList.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldName.length > 0);
          //   if (count == 0 && elements.length > 0) {
          //     if (elements[0].fieldName.includes('Address')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Address');
          //       this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
          //     }

          //     if (elements[0].fieldName.includes('Email')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Email');
          //       this.dynamicArrayTemp = this.dynamicArrayEdit;
          //     }

          //     if (elements[0].fieldName.includes('Phone')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Phone');
          //       this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
          //     }

          //     if (elements[0].fieldName.includes('Website')) {
          //       this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Website');
          //       this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
          //     }

          //     ArrayWithGroupedElement.push(elements[0]);             
          //   }
          //   if (count == 0 && elements.length == 0)
          //     ArrayWithGroupedElement.push(formControl);
          // });

          // this.coreUserList = ArrayWithGroupedElement;

          const Fields = {};
          this.coreUserList.forEach((formControl) => {
            // if (formControl.fieldName == 'Name') {
            //   //this.transactionUserName = this.taskDetailList.title;            
            // }
            // if (formControl.fieldName == 'Type') {           
            //   let type=this.TypeListForDropDown.find(x=>x.subFolderID==formControl.fieldValue);
            //   this.transactionUserRole = (type!=null ||type!=undefined)?type.folderName:""
            // }
            Fields[formControl.fieldName] = new FormControl('');
            // if (formControl.fieldName.length > 0) {
            //   Fields[formControl.fieldName + 'option'] = new FormControl('');

            //   let plcHolder = formControl.fieldName.find((x) => x.fieldID == formControl.fieldID);
            //   formControl.placeholderVal=plcHolder != null ? plcHolder.fieldName : formControl.fieldName;

            //  // let plcHolder = formControl.fieldNames.find((x) => x.fieldNameID == formControl.fieldNameID);
            //  // formControl.placeholderVal=plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            // }           
          });
          // this.ImagePathURL = (response.data.imageUrl==null || response.data.imageUrl==undefined || response.data.imageUrl=='')?'':response.data.imageUrl;

          // Fields['City'] = new FormControl();
          // Fields['State'] = new FormControl();
          // Fields['ZipCode'] = new FormControl();
          // Fields['Country'] = new FormControl();

          // address computaion array for computation
          //  this.addressFormGroup.push('Address');
          //  this.addressFormGroup.push('City');
          //  this.addressFormGroup.push('State');
          //  this.addressFormGroup.push('ZipCode');
          //  this.addressFormGroup.push('Country');

          //   Fields['fruitCtrl'] = this.fruitCtrl; 
          this.myFormGroup = new FormGroup(Fields);

          this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
          this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

          var data = [];

          data = this.coreUserList.filter((s) => s.fieldID == 0);

          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var DrpData = [];
              DrpData = data[i].data.filter((s) => s.fieldTypeName == 'Dropdown');
              if (DrpData.length > 0) {
                for (var v = 0, char = DrpData.length; v < char; ++v) {
                  this.dropdownlist.push(DrpData[v]);
                }
              }

              var MultiData = [];
              MultiData = data[i].data.filter((s) => s.fieldTypeName == 'MultiSelect');
              if (MultiData.length > 0) {
                for (var v = 0, char = MultiData.length; v < char; ++v) {
                  this.multipleDropdownList.push(MultiData[v]);
                }
              }

              var CheckboxData = [];
              CheckboxData = data[i].data.filter((s) => s.fieldTypeName == 'Checkbox');
              if (CheckboxData.length > 0) {
                for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                  this.checkBoxList.push(CheckboxData[v]);
                }
              }
            }
          }

          if (this.dropdownlist.length > 0) {
            var fieldListdrp = [];
            var value;
            for (let i = 0; i < this.dropdownlist.length; i++) {
              var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
              value = drpValue.split(',');
              var FieldsDrp = {
                FieldValue: this.dropdownlist[i].fieldName,
                value: value,
              };
              fieldListdrp.push(FieldsDrp);
            }
            this.dropdownlist = fieldListdrp;
          }

          if (this.multipleDropdownList.length > 0) {
            var fieldmulListdrp = [];
            var value;
            for (let i = 0; i < this.multipleDropdownList.length; i++) {
              var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
              value = muldrpValue.split(',');
              var FieldsMulDrp = {
                FieldValue: this.multipleDropdownList[i].fieldName,
                value: value,
              };
              fieldmulListdrp.push(FieldsMulDrp);
            }
            this.multipleDropdownList = fieldmulListdrp;
          }

          if (this.checkBoxList.length > 0) {
            var fieldcheckbox = [];
            var value;
            for (let i = 0; i < this.checkBoxList.length; i++) {
              var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
              value = checkboxValue.split(',');
              var FieldsCheckbox = {
                FieldValue: this.checkBoxList[i].fieldName,
                value: value,
              };
              fieldcheckbox.push(FieldsCheckbox);
            }
            this.checkBoxList = fieldcheckbox;
          }

          // Modified array containing group ends 
          this.fillCheckBoxList();
          this.prepareCheckboxListForUI();

          this.fillDropDown();
          this.prepareDropDownForUI();

          this.fillMultiDropDown();
          this.prepareMultiDropDownForUI();

          // //#region geting core filds
          // var reqModel={
          //   fileID: this.fileManagerItemID,
          //   documentTypeID:this.TypeIdDrp,
          //   userID : this.currentUser.UID,
          //   organizationID: Number(this.organizationId),
          //   databaseID: Number(this.databaseId),          
          //   officeID:this.myOfficeID,
          // }           
          // this.fileManagerService.getFileFields(reqModel).subscribe((response) => {
          //  var tempArryacoreFieldList=response.data.docTypeFields.filter((m) => m.fieldID == 0);
          //   response.data.docTypeFields = response.data.docTypeFields.filter((m) => m.fieldID > 0);
          //   this.coreFieldList = response.data.docTypeFields;
          //    // Modified array containing group starts
          //     // tempArryacoreFieldList.forEach(element => {
          //     //   if(element.data.length>1) {
          //     //     var indexArray=[];                  
          //     //     element.data.forEach(elementin => {
          //     //       if(elementin.fieldID>0){
          //     //         let grpele=this.coreUserList.find(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
          //     //         elementin.fieldValue=grpele!=undefined?grpele.fieldValue:"";
          //     //         elementin.id=grpele!=undefined?grpele.id:0;
          //     //         elementin.isRequired=grpele!=undefined?grpele.isRequired:false;
          //     //         if(elementin.fieldNames.length>0){
          //     //         elementin.fieldNameID=grpele.fieldNameID;
          //     //         elementin.placeholderVal=grpele.placeholderVal;                       
          //     //         }
          //     //         this.coreFieldList.push(elementin);
          //     //         if (!this.myFormGroup.contains(elementin.fieldName)){
          //     //           this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
          //     //         }
          //     //         var index = this.coreUserList.findIndex(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
          //     //         indexArray.push(index);
          //     //       }
          //     //     });                 

          //     //     this.coreUserList = this.coreUserList.filter(function(value, index) { 
          //     //       return indexArray.indexOf(index) == -1; 
          //     //     }) ;
          //     //     this.coreUserList.splice(indexArray[0],0,element);                  
          //     //   }
          //     // });            

          //     // ArrayWithGroupedElement.forEach(element => {
          //     //   if(element.fieldName=="Address"){
          //     //     if(element.address.length>0){
          //     //       if(element.address.find(m=>m.childFieldType==3)!=undefined)
          //     //         this.cityValue=element.address.find(m=>m.childFieldType==3).fieldValue;
          //     //         else
          //     //         this.cityValue="";
          //     //       if(element.address.find(m=>m.childFieldType==2)!=undefined)
          //     //         this.stateValue=element.address.find(m=>m.childFieldType==2).fieldValue;
          //     //         else
          //     //         this.stateValue="";
          //     //       if(element.address.find(m=>m.childFieldType==4)!=undefined)
          //     //         this.zipValue=element.address.find(m=>m.childFieldType==4).fieldValue;
          //     //         else
          //     //         this.zipValue="";
          //     //     }
          //     //   }
          //     // });

          //     this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          //     this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
          //     this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

          //     var data = [];

          //     data=this.coreUserList.filter((s) => s.fieldID ==0);

          //     if (data.length > 0) {
          //       for (var i = 0, len = data.length; i < len; ++i) {
          //         var DrpData = [];
          //         DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
          //         if(DrpData.length>0){
          //           for (var v = 0, char = DrpData.length; v < char; ++v) {
          //             this.dropdownlist.push(DrpData[v]);
          //           }
          //         }

          //         var MultiData=[];
          //         MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
          //         if(MultiData.length>0){
          //           for (var v = 0, char = MultiData.length; v < char; ++v) {
          //             this.multipleDropdownList.push(MultiData[v]);
          //           }
          //         }

          //         var CheckboxData=[];
          //         CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
          //         if(CheckboxData.length>0){
          //           for (var v = 0, char = CheckboxData.length; v < char; ++v) {
          //             this.checkBoxList.push(CheckboxData[v]);
          //           }
          //         }             
          //       }
          //     }               

          //       if (this.dropdownlist.length > 0) {
          //         var fieldListdrp = [];
          //         var value;
          //         for (let i = 0; i < this.dropdownlist.length; i++) {
          //           var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          //           value = drpValue.split(',');
          //           var FieldsDrp = {
          //             FieldValue: this.dropdownlist[i].fieldName,
          //             value: value,
          //           };
          //           fieldListdrp.push(FieldsDrp);
          //         }
          //         this.dropdownlist = fieldListdrp;
          //       }

          //       if (this.multipleDropdownList.length > 0) {
          //         var fieldmulListdrp = [];
          //         var value;
          //         for (let i = 0; i < this.multipleDropdownList.length; i++) {
          //           var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
          //           value = muldrpValue.split(',');
          //           var FieldsMulDrp = {
          //             FieldValue: this.multipleDropdownList[i].fieldName,
          //             value: value,
          //           };
          //           fieldmulListdrp.push(FieldsMulDrp);
          //         }
          //         this.multipleDropdownList = fieldmulListdrp;
          //       }

          //       if (this.checkBoxList.length > 0) {
          //         var fieldcheckbox = [];
          //         var value;
          //         for (let i = 0; i < this.checkBoxList.length; i++) {
          //           var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
          //           value = checkboxValue.split(',');
          //           var FieldsCheckbox = {
          //             FieldValue: this.checkBoxList[i].fieldName,
          //             value: value,
          //           };
          //           fieldcheckbox.push(FieldsCheckbox);
          //         }
          //         this.checkBoxList = fieldcheckbox;
          //       }   

          //     // Modified array containing group ends 
          //     this.fillCheckBoxList();
          //     this.prepareCheckboxListForUI();

          //     this.fillDropDown();
          //     this.prepareDropDownForUI();

          //     this.fillMultiDropDown();
          //     this.prepareMultiDropDownForUI();              
          //   });

          // this.dynamicArray=[];
          // this.dynamicArrayAddress=[];
          // this.dynamicArrayPhone=[];
          // this.dynamicArrayWebsite=[];
          // if(this.dynamicArrayTemp!=undefined){
          //   this.dynamicArrayTemp.forEach((e,i) => {
          //     this.appendEle(e, 1,i+1);
          //   });
          // }
          // if(this.dynamicArrayAddressTemp!=undefined){
          //   this.dynamicArrayAddressTemp.forEach((e,i) => {
          //     this.appendEle(e, 2,i+1);
          //   });
          // }

          // if(this.dynamicArrayPhoneTemp!=undefined){
          //   this.dynamicArrayPhoneTemp.forEach((e,i) => {
          //     this.appendEle(e, 3,i+1);
          //   });
          // }

          // if (this.dynamicArrayWebsiteTemp != undefined)
          //   this.dynamicArrayWebsiteTemp.forEach((e,i) => {
          //     this.appendEle(e, 4,i+1);
          //   });
          this.loaderService.hide();
          // if(this.isTypeChanged){
          // this.myFormGroup.get('Type').markAsDirty();
          //   this.isTypeChanged=false;
          // }
        } else {
          this.coreUserList = [];
          this.loaderService.hide();
        }
      } else {
        this.coreUserList = [];
        this.loaderService.hide();
      }
    });
  }

  fillCheckBoxList() {
    if (this.coreFieldList) {
      this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
    }
  }

  prepareCheckboxListForUI() {
    if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
      var fieldcheckbox = [];
      var value;
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      for (let i = 0; i < this.checkBoxList.length; i++) {
        var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
        value = checkboxValue.split(',');
        var selectedVal;
        let chk = this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);

        if (chk.length > 0) {
          selectedVal = chk[0].fieldValue;
        }
        else {
          selectedVal = this.checkBoxList[i].fieldValue
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }
        // if(chk.length==0){
        //   selectedVal="";
        // } 

        var FieldsCheckbox = {
          FieldValue: this.checkBoxList[i].fieldName,
          value: value,
          selectedCHK: selectedVal//this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
        };

        fieldcheckbox.push(FieldsCheckbox);

        let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
        for (let n = 0; n < selectedCHKArray.length; n++) {
          this.chkStatusArry.push({
            ckh: selectedCHKArray[n],
            fieldId: this.checkBoxList[i].fieldID,
          });
        }
      }
      this.checkBoxList = fieldcheckbox;
    }
  }

  fillMultiDropDown() {
    this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
  }

  prepareMultiDropDownForUI() {
    if (this.multipleDropdownList.length > 0) {
      var fieldmulListdrp = [];
      var value;
      for (let i = 0; i < this.multipleDropdownList.length; i++) {
        var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
        value = muldrpValue.split(',');
        var selectedVal;
        let drp = this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID);
        if (drp.length > 0) {
          selectedVal = drp[0].fieldValue;
        }
        else {
          selectedVal = this.multipleDropdownList[i].fieldValue
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }
        //  if(drp.length==0){
        //   selectedVal="";
        //  } 

        var FieldsMulDrp = {
          FieldValue: this.multipleDropdownList[i].fieldName,
          value: value,
          selectedVal: selectedVal// this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID).map((k) => k.fieldValue).toString().split(','),
        };
        fieldmulListdrp.push(FieldsMulDrp);
      }
      this.multipleDropdownList = fieldmulListdrp;
    }
  }

  fillDropDown() {
    this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
    this.dropdownlist.forEach(element => {
      if (element.fieldName == 'Type') { element.defaultValue = this.TypeList }
    });
  }

  prepareDropDownForUI() {
    if (this.dropdownlist.length > 0) {
      var fieldListdrp = [];
      var value;
      for (let i = 0; i < this.dropdownlist.length; i++) {

        if (this.dropdownlist[i].defaultValue.length > 0) {
          var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          value = drpValue.split(',');
          var selectedVal;
          let drp = this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID);
          if (drp.length > 0) {
            selectedVal = drp[0].fieldValue;
          }
          else {
            selectedVal = this.dropdownlist[i].fieldValue
          }

          if (selectedVal == undefined || selectedVal == null) {
            selectedVal = "";
          }
          // if(drp.length==0){
          //   selectedVal="";
          //  }

          var FieldsDrp = {
            FieldValue: this.dropdownlist[i].fieldName,
            value: value,
            selectedVal: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID).map((k) => k.fieldValue),
          };
          fieldListdrp.push(FieldsDrp);
        }
      }
      this.dropdownlist = fieldListdrp;
    }
  }

  isChecked(fieldName, chk) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    if (_newcheckBoxlist[0].selectedCHK != '') {
      return _newcheckBoxlist[0].selectedCHK.toString().includes(chk);
    } else {
      return false;
    }
  }

  getddlSelectedVal(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist[0] && _newdropdownlist[0].selectedVal != '' && _newdropdownlist[0].selectedVal != undefined) {
        return _newdropdownlist[0].selectedVal;
      } else {
        return '';
      }
    }
  }

  getMultiddlSelectedVal(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist[0] && _newMuldropdownlist[0].selectedVal != '' && _newMuldropdownlist[0].selectedVal != undefined) {
        if (fieldName != "Tags") {
          return _newMuldropdownlist[0].selectedVal.split(',');
        } else {
          return _newMuldropdownlist[0].selectedVal;
        }
      } else {
        return '';
      }
    }
  }

  OnChange($event: any, chk: any, fieldId: any) {
    let ckhchecked = [];
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {
      this.chkStatusArry.push({
        ckh: chk,
        fieldId: fieldId,
      });
    } else {
      if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
        this.chkStatusArry = this.chkStatusArry.filter(
          (item) =>
            item.ckh != chk
        );
      }
    }
  }

  getCheckBoxlist(fieldName) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    return _newcheckBoxlist[0] != undefined ? _newcheckBoxlist[0].value : "";
  }

  getdropdownlist(fieldName) {
    var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
    return _newdropdownlist[0] != undefined ? _newdropdownlist[0].value : "";
  }

  getMuldropdownlist(fieldName) {
    var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
    return _newMuldropdownlist[0] != undefined ? _newMuldropdownlist[0].value : "";
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    this.allTags;
    var check = [];
    check = this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if (check.length > 0) {
      this.fruitCtrl.setValue(null);
      return;
    }
    // Add our tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());
      if (index >= 0) {
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags = this.tags.map(function (el) {
      return el.trim();
    });
    const index = this.tags.indexOf(event.option.viewValue);

    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';
      //this.fruits.splice(index, 1);
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }

  clearDate(field) {
    return field.fieldValue = "";
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  isAISearch: boolean = false;
  documentName: string = "";
  isExactDocumentName: boolean = false;
  Tagkeywords: string = "";
  isExactKeywords: boolean = false;
  authorBy: string = "";
  authorByValue: string = "";
  arryaControlNameIdpare: any = [];
  tagvalues: string;

  searchAdvFilter(formValues) {

    if (formValues !== undefined) {
      var fieldList = [];
      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              // if (s.fieldName.length > 0) {
              //   s.fieldNameID =
              //   (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
              //       ? s.fieldNames[0].fieldNameID
              //       : Number(formValues[s.fieldName + 'option']);
              // }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if (key != 'Addressoption' && key != 'Emailoption' && key != 'Phoneoption' && !key.includes('option')) {
            if (control != undefined) {
              if (control.fieldName.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  value: formValues[key],
                  fieldNameID:
                    (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                      ? control.fieldNames[0].fieldNameID
                      : Number(formValues[key + 'option']),
                });
              }
            }

          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues = this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }

          }
          // if (tempList[0].fieldTypeName == 'Image') {
          //   if (formValues[key].length == 0) {
          //     selectedValues = '';
          //   } else {
          //     selectedValues = this.ImageUploadURL; 
          //   }
          // }
          let frmctrl = this.arryaControlNameIdpare.find(e => e.name == key);
          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
            SubFolderID: frmctrl != undefined ? frmctrl.subfolderID : 0,
            ChildFields: []
          };

          fieldList.push(Fields);
        }
      }
    }

    var NewfieldList = [];

    if (fieldList.length > 0) {
      fieldList.forEach((element) => {
        if (element.FieldValue != "" && element.FieldValue != null) {
          var obj = {
            fieldID: element.FieldID,
            value: element.FieldValue,
          };
          NewfieldList.push(obj);
        }
      });
    }

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == 'File Manager');
    if (Module.length > 0) {
      this.FileManagerFolderId = Module[0].folderID;
    }

    if (this.fromDate == "") {
      this.fromDate = null;
    }
    if (this.fromDate != null) {
      this.fromDate = moment(this.fromDate).format("MM/DD/YYYY");
    }
    if (this.toDate == "") {
      this.toDate = null;
    }
    if (this.toDate != null) {
      this.toDate = moment(this.toDate).format("MM/DD/YYYY");
    }
    if (this.fileType == "All") {
      this.fileType = null;
    }
    if (NewfieldList.length == 0) {
      NewfieldList = null;
    }
    if (this.pageModelData.pageIndex == 1) {
      this.pageModelData.pageIndex = 1;
      this.pageModelData.pageSize = this.pageModelData.pageSize;
    }
    this.pageModelData.pageIndex = this.pageModelData.pageIndex;
    this.pageModelData.pageSize = this.pageModelData.pageSize;

    if (this.isAISearch == true) {
      this.Tagkeywords = this.aisearchkeywords;
      // this.documentName="";
      // this.authorByValue="";
      // this.TypeIdDrp=0;
      // NewfieldList=null;
      // this.fileType="";
    }
    var reqModelSearch = {
      moduleFolderID: this.FileManagerFolderId,
      isAISearch: this.isAISearch,//this.isAISearch,
      documentName: this.documentName,
      isExactDocumentName: this.isExactDocumentName,
      keyword: this.Tagkeywords,
      isExactKeywords: this.isExactKeywords,
      author: this.authorByValue,
      documentType: Number(this.TypeIdDrp),
      fields: NewfieldList,
      createDate: {
        from: this.fromDate,
        to: this.toDate
      },
      fileType: this.fileType,
      pageIndex: this.pageModelData.pageIndex,
      pageSize: this.pageModelData.pageSize,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      sortColumn: "CreatedOn",
      sortDirection: "desc",
      isPaging: true
    }
    //return;
    this.loaderService.show();
    this.fileManagerService.advancedSearch(reqModelSearch).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.isAdvFilter = true;
          this.foldersList = this.responseHolder.data.fileManagerItems;
          this.documentTypeFieldsList = this.responseHolder.data.documentTypeFields;
          this.FieldColumnToogle = this.responseHolder.data.gridSetting;
          if (this.foldersList.length > 0) {
            this.foldersListShow = false;
          } else {
            this.foldersListShow = true;
          }
          if (this.FieldColumnToogle != null) {
            this.showCustomColumninList = this.FieldColumnToogle.filter(x => x.isDisplay == true);
          } else {
            this.showCustomColumninList = [];
          }
          this.paginatorTotalLength = this.responseHolder.data.count;
          this.pageModelData.pageIndex = this.responseHolder.data.pageIndex;
          this.pageIndex = this.responseHolder.data.pageIndex;
          this.pageSize = this.responseHolder.data.pageSize;
          this.close();
        } else {
          this.isAdvFilter = false;
          this.loaderService.hide();
        }
      } else {
        this.isAdvFilter = false;
        this.loaderService.hide();
      }
    });
  }

  ChangeIsExactDocumentName($event: MatRadioChange) {

    if ($event.value === '1') { // 1-Contain , 2-Exact Match
      this.isExactDocumentName = false;
    } else {
      this.isExactDocumentName = true;
    }
  }

  ChangeIsExactKeywords($event: MatRadioChange) {

    if ($event.value === '1') { // 1-Contain , 2-Exact Match
      this.isExactKeywords = false;
    } else {
      this.isExactKeywords = true;
    }
  }


  fileTypeSelection(event) {
    var check = [];
    check = this.fileTypes.filter(x => x.value == event.value);
    if (check.length > 0) {
      this.fileType = check[0].name;
    }
  }

  authorSelection(event) {
    var check = [];
    check = this.getAuthorList.filter(x => x.value == event.value);
    if (check.length > 0) {
      this.authorByValue = event.value;
      this.authorBy = check[0].name;
    }
  }

  fromDateChange(type: string, event: MatDatepickerInputEvent<Date>) {
    this.minToDate = event.value;
    this.fromDate = moment(event.value).format("MM/DD/YYYY");
    if (event.value !== null) {
      this.maxToDate = new Date(
        event!.value.getFullYear(),
        event!.value.getMonth(),
        event!.value.getDate() + 30
      );
    }
  }

  toDateChange(type: string, event: MatDatepickerInputEvent<Date>) {
    this.maxFromDate = event.value;
    this.toDate = moment(event.value).format("MM/DD/YYYY");
    if (event.value !== null) {
      this.minFromDate = new Date(
        event!.value.getFullYear(),
        event!.value.getMonth(),
        event!.value.getDate() - 30
      );
    }
  }


  FromDate(event: any): void {
    this.fromDate = moment(event.value).format("MM/DD/YYYY");

    // if (this.fromDate && this.toDate) {
    //   if (this.fromDate > this.toDate) {
    //     this.fromDate = null;
    //     this.toastr.warning('From date should not be greater than To date.', '', {
    //       timeOut: 3000,
    //     });
    //   }
    // }
  }

  ToDate(event: any): void {
    this.toDate = moment(event.value).format("MM/DD/YYYY");

    // if (this.fromDate && this.toDate) {
    //   if (this.toDate < this.fromDate) {
    //     this.toDate = null;
    //     this.toastr.warning('To date should not be less than From date.', '', {
    //       timeOut: 3000,
    //     });
    //   }
    // }
  }


  searchUser(val) {
    if (val.length >= 2) {
      this.userList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getUserListCoreImplementation(val)
        }, 500);
      } else {
        this.userList = [];
      }
    }
  }

  getUserListCoreImplementation(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.userList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.fileManagerService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.userList = response.data.userModel;
          this.userList.map((res) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.userList = this.userList;
        }
      }
    });
  }

  usersSelected(userSelected: any) {
    this.authorBy = userSelected.firstName + " " + userSelected.lastName;
  }

  tagSelected(userSelected: any) {
    this.Tagkeywords = userSelected.tagName;
  }

  getTagListResponseHolder: any = [] = [];

  getAllTagsList(tag) {
    var obj = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      tagName: tag,
      PageSize: 0
    }
    this.fileManagerService.getAllTagsList(obj).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagListWithId;
        }
        else {
          this.allTags = [];
        }
      }
    });
  }

  getAuthorList = [];

  getFileAuthorsList() {
    var obj = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId)
    }
    this.fileManagerService.getFileAuthors(obj).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.getAuthorList = this.getTagListResponseHolder.data;
        }
        else {
          this.getAuthorList = [];
        }
      }
    });
  }

  getfileTypesList() {
    var obj = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId)
    }
    this.fileManagerService.getFileTypes(obj).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.fileTypes = this.getTagListResponseHolder.data;
          if (this.fileTypes.length > 0) {
            let counter = 1; // Initialize a counter to increment the value
            this.fileTypes.forEach(e => {
              e.values = e.value;   // Keep the original value in e.values
              e.value = counter;    // Assign the incremented counter value to e.value
              counter++;            // Increment the counter
            });
          }
        }
        else {
          this.fileTypes = [];
        }
      }
    });
  }

  VectorDocumentID: any = "";

  processDocumentToVectorDB(form) {
    var ReqModel = {
      modelId: 'prebuilt-document',
      url: form.azureblobPath,
    }
    this.loaderService.show();
    this.fileManagerService.ExtractTextForFileManagerListProcessIcon(ReqModel).subscribe(async response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {

          //

          const userId = this.currentUser.UID;
          const officeId = this.myOfficeID;
          const organizationId = this.organizationId;
          this.loaderService.show();
          this.fileManagerService.processDocument(form.azureblobPath, userId, officeId, organizationId, this.responseHolder.data.content).subscribe(
            response => {
              if (response.success) {
                this.toastr.success('Document processed successfully')
                //this.VectorDocumentID=response.message;
                this.AddVectorFileID(response.message, form);
                this.loaderService.hide();

              } else {
                this.loaderService.hide();
              }
            },
            error => {
              this.loaderService.hide();
            }
          );

          //
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  // processDocumentToVectorDB(form) {     
  //   const userId = this.currentUser.UID;
  //   const officeId = this.myOfficeID;
  //   const organizationId = this.organizationId;
  //   this.loaderService.show();
  //   this.fileManagerService.processDocument(form.azureblobPath, userId, officeId, organizationId).subscribe(
  //     response => {
  //       if (response.success) {        
  //         this.toastr.success('Document processed successfully')
  //         //this.VectorDocumentID=response.message;
  //         this.AddVectorFileID(response.message,form);
  //         this.loaderService.hide();

  //       } else {        
  //         this.loaderService.hide();
  //       }
  //     },
  //     error => {      
  //       this.loaderService.hide();
  //     }
  //   );
  // }     

  AddVectorFileID(vectorFileID: any, document) {
    var ReqModel = {
      docFrom: 4,
      documentID: document.fileManagerItemID,
      vectorFileID: vectorFileID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    }
    this.fileManagerService.AddVectorFileID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
          this._dataSharingService.sendRefreshListForFileManager(true);
          this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager("");
          this.selectedRecordDeleteArray = [];
          this.selection.clear();
          this.showFavDeletePanel = false;
        } else {
        }
      } else {
      }
    });
  }

  enableAIChange(event: any) {
    if (event.checked == true) {
      this.isAISearch = true;
    } else {
      this.isAISearch = false;
    }
  }


  open3Cpopup() {
    const dialogRef = this.dialog.open(Add3cforPccComponent, {
      data: {
        //moduleName:this.mainModulename,      
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        // this.getActivityEMails3C();
      }
    });
  }

  selecteddocumentCategory: number = 0;
  //documentCategoryList:any=[]=[];
  paycheckErrorList: any = [] = [];
  isReCreate: boolean = false;

  GetDocumentCategory(templateRef: TemplateRef<any>) {
    this.selecteddocumentCategory = 0;
    this.documentCategoryList = [];
    var request = {
      userId: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    };
    this.loaderService.show();
    this.fileManagerService.GetDocumentCategoriesPCC(request).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          if (this.responseHolder.data == undefined
            || this.responseHolder.data.isUploadEnabled == undefined) {
            this.toastr.error('Some Error occured.', '', {
              timeOut: 3000
            });
          } else if (!this.responseHolder.data.isUploadEnabled) {
            this.toastr.error('Document storage is not enabled for the Facility.', '', {
              timeOut: 3000
            });
          } else if (this.responseHolder.data.elements != undefined) {
            this.documentCategoryList = this.responseHolder.data.elements.filter(m => m.type == 0);
            let quota = this.responseHolder.data.elements.find(m => m.type == 1);
            if (quota != undefined && quota.code == '100') {
              var obj = {
                name: "Temporary API Service Unavailability",
                code: "API will start functioning at " + new Date(quota.xQuotaTimeToResetDateTime),
                description: quota.detail,
              }
              this.paycheckErrorList.push(obj);
              this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
              return;
            }
            const dialogRef = this.dialog.open(templateRef, {
              panelClass: 'custom-modalbox'
            });
          }
        }
        else {
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  showPaycheckError(title: any = null) {
    const dialogRef = this.dialog.open(PaycheckErrorComponent, {
      data: {
        list: this.paycheckErrorList,
        title: title,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isReCreate = result;
      }
    });
  }

  selectDocumentCategory(event) {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(Add3cforPccComponent, {
      data: {
        files: this.selectedRecordDeleteArray,
        selecteddocumentCategory: this.selecteddocumentCategory
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
        this._dataSharingService.sendRefreshListForFileManager(true);
        this.showFavDeletePanel = false;
        this.selectedRecordDeleteArray = [];
        this.selection.clear();
      }
    });
  }


  currentIndex: number = 0;
  aiAutomationTemplateID: number = 0;
  ShowNoRecordFoundAITemplates: boolean = false;
  selectedFolderIdforAITemplate: number = 0;
  aITemplateList: any = [] = [];
  ShowNoRecordFound: boolean = false;
  FolderIdForAITemplates: number = 0;
  selectedFolderName: string = "";
  OpenPopUpFrom: string = "";
  closeAIAutomationTemplate() {
    this.dialog.closeAll();
  }

  getAIAutomationCategoryForImport(e: any, i: any) {
    //this.TemplateIDImportTask=0;
    //this.selectedTemplate=[];
    this.currentIndex = i;
    //this.selectedcategoryIDForImportTemp=e;
    //this.getOCRTemplate();
  }

  SelectAITemplate(data) {
    this.aiAutomationTemplateID = data.aiAutomationTemplateID;
  }

  openAITemplate(templateRef: TemplateRef<any>, data, OpenFrom) {
    this.OpenPopUpFrom = OpenFrom;
    this.selectedFolderName = data.name;
    this.aiAutomationTemplateID = 0;
    this.FolderIdForAITemplates = data.fileManagerItemID;
    this.getAIAutomationTemplates();
    this.dialog.open(templateRef);
  }

  permissionType: number = 0;

  openAITemplateSharedWithMe(templateRef: TemplateRef<any>, data, OpenFrom) {
    this.permissionType = data.permissionType;
    this.OpenPopUpFrom = OpenFrom;
    this.selectedFolderName = data.name;
    this.aiAutomationTemplateID = 0;
    this.FolderIdForAITemplates = data.id;
    this.getAIAutomationTemplates();
    this.dialog.open(templateRef);
  }

  getAIAutomationTemplates() {
    this.loaderService.show();
    var ReqModel = {
      keyword: "",
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.fileManagerService.getAIAutomationTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.aITemplateList = this.responseHolder.data.templates;
          if (this.aITemplateList == null) {
            this.aITemplateList = [];
          }
          if (this.aITemplateList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.aITemplateList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.aITemplateList = [];
        this.ShowNoRecordFound = true;
        this.loaderService.hide();
      }
    });
  }

  runFileAi: boolean = false;

  attachAIAutomationTemplate() {
    if (this.OpenPopUpFrom == 'Folder') {
      var ReqModel = {
        folderID: this.FolderIdForAITemplates,
        aiAutomationTemplateID: this.aiAutomationTemplateID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID: this.myOfficeID,
      }
      //return;
      this.loaderService.show();
      this.fileManagerService.attachAIAutomationTemplate(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.toastr.success('AI Template attach successfully selected folder.', '', {
              timeOut: 3000,
            });
            this.dialog.closeAll();
            // if(this.isSharedWithMe==false){
            //   this.getFileManagerFoldersList(this.parentId,this.pageModelData,"");
            //   this._dataSharingService.sendRefreshListForFileManager(true);
            //   this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager("");              
            //   this.selectedRecordDeleteArray = [];
            //   this.selection.clear();
            //   this.showFavDeletePanel = false;
            // }
            // if(this.isSharedWithMe==true){
            //   if(this.parentId==0){
            //     this.menuHeader = [];
            //     this.parentId=0;  
            //     this.selectedRecordDeleteArray = [];
            //     this.selection.clear();
            //     this.showFavDeletePanel = false;
            //     this.getFileFolderSharedWithMeList();
            //     this._dataSharingService.sendSelectedFolderIDForAddFolder(0);
            //     this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
            //     }else{
            //       this.getFileManagerFoldersListSharedWithMe(this.parentId,this.pageModelData,this.permissionType);
            //     }
            // }
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
    if (this.OpenPopUpFrom == 'File') {
      var ReqModel1 = {
        fileID: this.FolderIdForAITemplates,
        aiAutomationTemplateID: this.aiAutomationTemplateID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID: this.myOfficeID,
      }
      this.runFileAi = true;
      this.dialog.closeAll();
      this.toastr.success('The automation process may take a few minutes. You can continue other tasks on Flowtrics and refresh the list later to check the status.', '', {
        timeOut: 3000,
      });
      if (this.isSharedWithMe == false) {
        if (this.foldersList != null) {
          //this.foldersList.filter(x=>x.fileManagerItemID== this.FolderIdForAITemplates); 
          this.foldersList.find((item) => item.fileManagerItemID == this.FolderIdForAITemplates).aiProcessStatus = 1;
        }
      }
      if (this.isSharedWithMe == true) {
        if (this.SharedWithMeFormFolderList != null) {
          this.SharedWithMeFormFolderList.find((item) => item.id == this.FolderIdForAITemplates).aiProcessStatus = 1;
        }
      }
      this.fileManagerService.aIAutomationRunManuallyForFile(ReqModel1).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;

          if (this.isSharedWithMe == false) {
            this._dataSharingService.sendRefreshListForFileManager(true);
            this._dataSharingService.sendRefreshListForFileManagerAddFolder(this.parentId);
          }
          if (this.isSharedWithMe == true) {
            if (this.parentId == 0) {
              this.getFileFolderSharedWithMeList();
            }
            if (this.parentId > 0) {
              this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, this.permissionTypeForSharedWithMe);
            }
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  developerKey = 'AIzaSyAgB9FEebHKjW6KsupYIm_il2vx9TqZM04';//'your api key';
  clientId = "745090185837-up4beqop4vmmkkhu76cqqgmvnvon17ia.apps.googleusercontent.com"; //"your id"
  scope = [
    'profile',
    'email',
    'https://www.googleapis.com/auth/drive.file'//insert scope here
  ].join(' ');
  pickerApiLoaded = false;
  oauthToken?: any;


  signInGoogleDrive() {
    const accessToken = sessionStorage.getItem('access_token');
    if (!accessToken) {
      this.authService.signIn();
      return;
    } else {
      this.openDrive();
    }
  }


  openDrive(): void {
    const accessToken = sessionStorage.getItem('access_token');
    if (!accessToken) {
      // this.toastr.warning('Please sign in first.', '', {
      //   timeOut: 3000,
      // });  
      this.authService.signIn();
      return;
    }
    gapi.load('picker', () => {
      const picker = new google.picker.PickerBuilder()
        .addView(google.picker.ViewId.DOCS)
        //.enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setOAuthToken(accessToken) // Pass the OAuth token here
        //.setDeveloperKey('AIzaSyB4e2ulzqQW3n5nwV62sOnhlbMzwUX-Iug') //paul
        .setDeveloperKey('AIzaSyAgB9FEebHKjW6KsupYIm_il2vx9TqZM04') //Admin Flowtrics
        // .setCallback(this.pickerCallback)
        .setCallback((data) => this.pickerCallback(data))
        .build();
      picker.setVisible(true);
    });
  }

  pickerCallback(data: any) {
    var url = "";
    if (data.action === google.picker.Action.PICKED) {
      let doc = data[google.picker.Response.DOCUMENTS][0];
      url = doc[google.picker.Document.URL];
      this.fileId = data.docs[0].id;
      if (this.fileId) {
        this.downloadFiles(this.fileId, data.docs[0].name);
      }
    } else {
    }
  }

  downloadFiles(fileId: string, selectedfileName: string): void {
    const url = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;
    const accessToken = sessionStorage.getItem('access_token');
    fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((response) => response.blob())
      .then((blob) => {
        const fileName = selectedfileName; // Replace with actual file name if available
        const file = this.convertBlobToFile(blob, fileName);
        this.selectFilesFromDragZoneFromGoogleDrive(file);
      })
      .catch((error) => console.error('Download error:', error));
  }

  convertBlobToFile(blob: Blob, fileName: string): File {
    // Add metadata for lastModifiedDate
    const lastModifiedDate = new Date();
    const file = new File([blob], fileName, {
      type: blob.type,
      lastModified: lastModifiedDate.getTime(),
    });
    return file;
  }

  selectFilesFromDragZoneFromGoogleDrive(files) {
    this.dialog.closeAll();
    this.loaderService.show();

    if (!files) {
      this.toastr.error('No files selected.', '', { timeOut: 3000 });
      this.loaderService.hide();
      return;
    }

    const chunkSize = 10 * 1024 * 1024; // 5 MB per chunk
    let UploadedFilesDragZone = [];
    UploadedFilesDragZone.push(files); // Convert FileList to Array

    const processFile = async (file: File) => {
      const fileName = file.name;

      // Validate file name length
      if (fileName.split('.')[0].length > 120) {
        this.toastr.warning(
          'File name up to 120 characters only supported, please rename the file.',
          '',
          { timeOut: 3000 }
        );
        this.InputFile.nativeElement.value = '';
        this.loaderService.hide();
        return;
      }

      // Validate file name for special characters
      const documentNameSplit = fileName.split('.');
      if (documentNameSplit.length > 2) {
        this.toastr.warning(
          'Please upload a valid file name or remove special characters.',
          '',
          { timeOut: 3000 }
        );
        this.InputFile.nativeElement.value = '';
        this.loaderService.hide();
        return;
      }

      const documentName = documentNameSplit[0];
      const documentType = documentNameSplit[1];

      const totalChunks = Math.ceil(file.size / chunkSize);
      let intervalId: any;
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append('fileChunk', chunk);
        formData.append('chunkIndex', i.toString());
        formData.append('totalChunks', totalChunks.toString());
        formData.append('fileName', fileName);
        formData.append('FileDetailList', `${documentName}|${documentType}`);
        formData.append('ParentID', this.parentId.toString());
        formData.append('UserID', this.currentUser.UID);
        formData.append('OrganizationID', this.organizationId);
        formData.append('OfficeID', this.myOfficeID);
        formData.append('DatabaseID', this.databaseId);

        try {
          if (i + 1 == totalChunks) {
            intervalId = this.showEngagingToaster(fileName);
          }
          await this.fileManagerService.uploadChunk(formData).toPromise();
          this.toastr.clear();
          this.toastr.info(`Chunk ${i + 1}/${totalChunks} uploaded for ${fileName}`, '', {
            timeOut: 1000,
          });
        } catch (error) {
          this.loaderService.hide();
          this.toastr.error(`An error occurred during chunk upload for ${fileName}.`, '', {
            timeOut: 3000,
          });
          return;
        }
      }
      if (intervalId)
        this.clearEngagingToaster(intervalId, `File ${fileName} uploaded successfully!`);
      // this.toastr.success(`File ${fileName} uploaded successfully.`, '', { timeOut: 3000 });
    };

    const uploadFiles = async () => {
      for (const file of UploadedFilesDragZone) {
        await processFile(file);
      }

      this.loaderService.hide();
      this._dataSharingService.sendRefreshListForFileManager(true);
      this._dataSharingService.sendRefreshListForFileManagerAddFolder(this.parentId);
      this.formDialog.reset();
    };

    uploadFiles();

  }

  selectFilesFromDragZoneFromGoogleDrive1(files) {
    this.dialog.closeAll();
    this.loaderService.show();
    this.formData = new FormData();
    this.UploadedFilesDragZone = [];

    this.UploadedFilesDragZone.push(files);

    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        this.InputFile.nativeElement.value = "";
        return;
      }
      var documenttype = "";
      var documentName = "";
      var FullPath = this.UploadedFilesDragZone[i].name;

      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      var documentNameSplit = newfilename.split('.');

      // var documentNameSplit = FullPath.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];

      // if(documentNameSplit.length>2){
      //   this.toastr.warning('Please upload valid file name, or remove special character.', '', {
      //     timeOut: 3000,
      //   });
      //   this.InputFile.nativeElement.value = "";
      //   this.loaderService.hide(); 
      //   return;
      // }
      //documentName = documentName.substring(0, 30);//get first 30 chars

      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('FileDetailList', documentName + '|' + documenttype);
    }
    this.formData.append("ParentID", this.parentId.toString());
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    //this.formData.append('OfficeIDList', this.OfficeIDList);
    this.formData.append('DatabaseID', this.databaseId);
    this.fileManagerService.addFilemanagerFile(this.formData).subscribe(response => {
      if (response != undefined) {
        var responseHolder = response;
        this.loaderService.hide();
        if (responseHolder.data == true && responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('File upload successfully.', '', {
            timeOut: 3000,
          });
          this._dataSharingService.sendRefreshListForFileManager(true);
          this._dataSharingService.sendRefreshListForFileManagerAddFolder(this.parentId);
          this.formDialog.reset();
        }
        if (responseHolder.data == 2 && responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.toastr.warning('File already exist.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
      }
    });

  }

  showOnlyDocs(event: MatSlideToggleChange) {
    this.isFilesOnly = event.checked;
    if (this.parentId == 0) {
      this.getFileManagerFoldersList(0, this.pageModelData, "");
    } else {
      this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
    }
  }

  ReRunAutomationForAITool(data: any) {
    var ReqModel = {
      aiAutomationID: data.aiAutomationID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.dialog.closeAll();
    this.toastr.success('The automation process may take a few minutes. You can continue other tasks on Flowtrics and refresh the list later to check the status.', '', {
      timeOut: 3000,
    });
    if (this.isSharedWithMe == false) {
      if (this.foldersList != null) {
        this.foldersList.find((item) => item.fileManagerItemID == data.fileManagerItemID).aiProcessStatus = 1;
      }
    }
    this.fileManagerService.reRunAutomationForAITool(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  ReRunAutomationForAIToolSharedWithMe(data: any) {
    var ReqModel = {
      aiAutomationID: data.aiAutomationID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.dialog.closeAll();
    this.toastr.success('The automation process may take a few minutes. You can continue other tasks on Flowtrics and refresh the list later to check the status.', '', {
      timeOut: 3000,
    });
    if (this.isSharedWithMe == true) {
      if (this.SharedWithMeFormFolderList != null) {
        this.SharedWithMeFormFolderList.find((item) => item.id == data.id).aiProcessStatus = 1;
      }
    }
    this.fileManagerService.reRunAutomationForAITool(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
      }
      else {
        this.loaderService.hide();
      }
    });
  }


  //=========== Upload Files ================//

  UploadedFiles: any = [] = [];
  //@ViewChild('Input') InputFile: ElementRef;
  selectedFiles: FileList;
  IsNew: boolean = false;
  totalPDFPages: number = 0;
  ResponseHolderDetails: any = [] = [];
  pdfURL: string = "";
  fileManagerItemIdForAddDoc: any;
  totalNumberPages: number = 0;
  pdfarray: any;
  parentIDForAddFiles: any;

  async loadPdf(data: Uint8Array, id): Promise<void> {
    const pdf = await (window as any).pdfjsLib.getDocument(data).promise;
    var totalUploadedPages = pdf.numPages;
    this.UploadedFiles.find((item) => item.id == id).pageCount = totalUploadedPages;
    this.totalPDFPages += totalUploadedPages;
  }

  openPanelMergePDF(templateRef: TemplateRef<any>, folder: any, From: any) {
    this.loadPdfJs('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.min.js');
    this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup',
    });

    this.documentName = folder.name;
    this.totalPDFPages = 0;
    this.totalNumberPages = 0;
    this.parentIDForAddFiles = folder.parentID;

    if (From == "Drive") {
      this.fileManagerItemIdForAddDoc = Number(folder.fileManagerItemID);
      this.pdfURL = folder.azureblobPath;
    }
    if (From == "SharedWimMe") {
      this.fileManagerItemIdForAddDoc = Number(folder.id);
      this.pdfURL = folder.url;
    }
    this.MergedFileHistoryList = [];
    this.UploadedFiles = [];
    this.IsNew = false;
    this.FetchDocAsync();
    this.getMergedFileHistory();
  }

  closeMergPDF() {
    this.MergedFileHistoryList = [];
    this.UploadedFiles = [];
    this.dialog.closeAll();
  }

  selectFilesFromDragZoneForAddDoc(event) {
    this.selectedFiles = event.target.files;
    const input = event.target as HTMLInputElement;
    for (let i = 0; i < this.selectedFiles.length; i++) {
      var ext = this.selectedFiles[i].name.split('.').pop();
      if (ext.toLowerCase() != 'pdf') {
        this.toastr.warning('Only PDF are allowed', '', {
          timeOut: 3000,
        });
        return;
      }

      const file = event.target.files[i];
      const files = event.target.files[i];

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = this.selectedFiles[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        // var documenttype = documentNameSplit[1];
        var documenttype = this.selectedFiles[i].name.split('.').pop();
        // const typedArray = new Uint8Array(reader.result as ArrayBuffer);
        //var base64String = reader.result;
        var size = this.getReadableFileSizeString(this.selectedFiles[i].size);
        // var count = reader.result.match(/\/Type[\s]*\/Page[^s]/g).length;

         documentName= documentName.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

        var ReqModel = {
          id: this.randomId(),
          fileName: documentName,
          // progress: 0,
          //  base64: base64String,
          documentType: documenttype,
          //action: 0,
          //isDeleted: false,
          //projectDocumentID: 0,
          file: this.selectedFiles[i],
          Totalsize: size,
          pageCount: 0,
        };
        this.UploadedFiles.push(ReqModel);
        if (files) {
          const fileReader = new FileReader();
          fileReader.onload = (e) => {
            const typedArray = new Uint8Array(fileReader.result as ArrayBuffer);
            this.loadPdf(typedArray, ReqModel.id);
          };
          fileReader.readAsArrayBuffer(file);
        }
      };
    }
  }

  randomId() {
    return Math.random();
  }

  getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
  }

  isNewToggle(event: any) {
    if (event.checked == true) {
      this.IsNew = true;
      this.documentNames = this.documentName + '_new';
    }
    if (event.checked == false) {
      this.IsNew = false;
      this.documentNames = this.documentName;
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.UploadedFiles,
      event.previousIndex,
      event.currentIndex
    );
  }

  deleteFileFromUploaded(file, removeIndex) {
    if (removeIndex !== -1) this.UploadedFiles.splice(removeIndex, 1);
    this.totalPDFPages -= file.pageCount;
  }

  mergePdf() {
    this.formData = new FormData();
    var isNewFile: string = '';
    if (this.IsNew == true) {
      isNewFile = 'true';
      if (this.documentNames == '') {
        this.toastr.warning('Please add document name.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    if (this.IsNew == false) {
      isNewFile = 'false';
      this.documentNames = this.documentName;
    }

    for (let i = 0; i < this.UploadedFiles.length; i++) {
      if (this.UploadedFiles[i].file !== '') {
        var documenttype = "";
        var documentName = "";
        var FullPath = this.UploadedFiles[i].file.name;
        var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
        var documentNameSplit = newfilename.split('.');
        documentName = documentNameSplit[0];
        documenttype = documentNameSplit[1];

        documentName=documentName.replace(/[,\#\[\]\(\)\{\}<>\/\\\|\?\*\":;!@\$%^&=~`'+]/g, '');

        this.formData.append('Files', this.UploadedFiles[i].file);
        this.formData.append('FileDetailList', documentName + '|' + documenttype);
      }
    }
    this.formData.append('FolderID', this.parentIDForAddFiles);
    this.formData.append('FileManagerID', this.fileManagerItemIdForAddDoc);
    this.formData.append('FilePath', this.pdfURL);
    this.formData.append('FileName', this.documentNames);
    this.formData.append('IsNew', isNewFile);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('DatabaseID', this.databaseId);
    this.loaderService.show();
    this.fileManagerService.mergePdfFiles(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {
          this.toastr.success('File Merged successfully.', '', {
            timeOut: 3000,
          });
          this.closeMergPDF();
          if (this.isSharedWithMe == false) {
            this.openAIToolDetail = false;
            this.getFileManagerFoldersList(this.parentId, this.pageModelData, "");
            this.searchName = "";
            this.showAddContact = false;
          } else {
            this.openAIToolDetail = false;
            this.searchName = "";
            this.showAddContact = false;
            if (this.parentId == 0) {
              this.getFileFolderSharedWithMeList();
            }
            if (this.parentId > 0) {
              this.getFileManagerFoldersListSharedWithMe(this.parentId, this.pageModelData, this.permissionTypeForSharedWithMe);
            }
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  async FetchDocAsync() {
    if (this.pdfURL != '') {
      this.loaderService.show();
      var ReqModel = { url: this.pdfURL };
      this.fileManagerService.FetchDocAsync(ReqModel).then((response) => response.arrayBuffer())
        .then(async (arrayBuffer) => {
          // Call both render methods
          this.pdfarray = arrayBuffer;
          this.renderPDFWithBoundingBox();
        })
        .catch((error) => {
          this.loaderService.hide();
        });
    }
  }

  async renderPDFWithBoundingBox() {
    this.loaderService.hide();
    // Use PDF.js to load the PDF document
    const loadingTask = (window as any).pdfjsLib.getDocument({
      data: this.pdfarray,
    });
    const pdf = await loadingTask.promise;
    this.totalNumberPages = pdf.numPages;
    this.totalPDFPages = this.totalNumberPages;
  }

  async loadPdfJs(src: string) {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    // script.onload = async () => {
    //   await this.FetchDocAsync(); // Call the method here
    // };
    script.onerror = () => console.error('Error loading PDF.js');
    this.renderer.appendChild(document.head, script);
  }

  MergedFileHistoryList: any = [] = [];

  getMergedFileHistory() {
    var ReqModel = {
      fileID: this.fileManagerItemIdForAddDoc,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.fileManagerService.getMergedFileHistory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.MergedFileHistoryList = this.responseHolder.data;
          if (this.MergedFileHistoryList == null) {
            this.MergedFileHistoryList = [];
          }
          if (this.MergedFileHistoryList.length > 0) {
            //this.ShowNoRecordFound=false;
          } else {
            // this.ShowNoRecordFound=true;
          }
        }
        else {
          // this.ShowNoRecordFound=true;
          this.MergedFileHistoryList = [];
        }
      }
      else {
        this.MergedFileHistoryList = [];
        //this.ShowNoRecordFound=true;        
      }
    });
  }

  sortDirection: 'asc' | 'desc' = 'asc';



  sortByCreatedOn(): void {
    if (!this.foldersList || this.foldersList.length === 0) return;

    // Parse ISO date string
    const parseDate = (dateStr: string): Date | null => {
      if (!dateStr) return null;
      const date = new Date(dateStr);
      return isNaN(date.getTime()) ? null : date;
    };

    // Create a new sorted array to trigger change detection
    this.foldersList = [...this.foldersList].sort((a, b) => {
      const dateA = parseDate(a.createdOn) || new Date(0); // Invalid dates first
      const dateB = parseDate(b.createdOn) || new Date(0); // Invalid dates first

      const timeA = dateA.getTime();
      const timeB = dateB.getTime();

      return this.sortDirection === 'asc' ? timeA - timeB : timeB - timeA;
    });

    // Toggle sort direction for next call
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }


  sortByCreatedOnSharedWithMe(): void {
    if (!this.SharedWithMeFormFolderList || this.SharedWithMeFormFolderList.length === 0) return;

    // Parse ISO date string
    const parseDate = (dateStr: string): Date | null => {
      if (!dateStr) return null;
      const date = new Date(dateStr);
      return isNaN(date.getTime()) ? null : date;
    };

    // Create a new sorted array to trigger change detection
    this.SharedWithMeFormFolderList = [...this.SharedWithMeFormFolderList].sort((a, b) => {
      const dateA = parseDate(a.createdOn) || new Date(0); // Invalid dates first
      const dateB = parseDate(b.createdOn) || new Date(0); // Invalid dates first

      const timeA = dateA.getTime();
      const timeB = dateB.getTime();

      return this.sortDirection === 'asc' ? timeA - timeB : timeB - timeA;
    });

    // Toggle sort direction for next call
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }

  // sortByCreatedOnSharedWithMe() {
  //   if (!this.SharedWithMeFormFolderList) return;

  //   this.SharedWithMeFormFolderList.sort((a, b) => {
  //     const dateA = new Date(a.createdOn);
  //     const dateB = new Date(b.createdOn);

  //     if (this.sortDirection === 'asc') {
  //       return dateA.getTime() - dateB.getTime();
  //     } else {
  //       return dateB.getTime() - dateA.getTime();
  //     }
  //   });

  //   // Toggle direction for next click
  //   this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  // }
}

